var es = Object.defineProperty;
var ts = (i, e, t) => e in i ? es(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var R = (i, e, t) => (ts(i, typeof e != "symbol" ? e + "" : e, t), t), ns = (i, e, t) => {
  if (!e.has(i))
    throw TypeError("Cannot " + t);
};
var Vt = (i, e, t) => {
  if (e.has(i))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(i) : e.set(i, t);
};
var lt = (i, e, t) => (ns(i, e, "access private method"), t);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const ft = window, fn = ft.ShadowRoot && (ft.ShadyCSS === void 0 || ft.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, gn = Symbol(), jn = /* @__PURE__ */ new WeakMap();
let bi = class {
  constructor(e, t, n) {
    if (this._$cssResult$ = !0, n !== gn)
      throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = e, this.t = t;
  }
  get styleSheet() {
    let e = this.o;
    const t = this.t;
    if (fn && e === void 0) {
      const n = t !== void 0 && t.length === 1;
      n && (e = jn.get(t)), e === void 0 && ((this.o = e = new CSSStyleSheet()).replaceSync(this.cssText), n && jn.set(t, e));
    }
    return e;
  }
  toString() {
    return this.cssText;
  }
};
const is = (i) => new bi(typeof i == "string" ? i : i + "", void 0, gn), oe = (i, ...e) => {
  const t = i.length === 1 ? i[0] : e.reduce((n, s, r) => n + ((o) => {
    if (o._$cssResult$ === !0)
      return o.cssText;
    if (typeof o == "number")
      return o;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + o + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(s) + i[r + 1], i[0]);
  return new bi(t, i, gn);
}, ss = (i, e) => {
  fn ? i.adoptedStyleSheets = e.map((t) => t instanceof CSSStyleSheet ? t : t.styleSheet) : e.forEach((t) => {
    const n = document.createElement("style"), s = ft.litNonce;
    s !== void 0 && n.setAttribute("nonce", s), n.textContent = t.cssText, i.appendChild(n);
  });
}, Wn = fn ? (i) => i : (i) => i instanceof CSSStyleSheet ? ((e) => {
  let t = "";
  for (const n of e.cssRules)
    t += n.cssText;
  return is(t);
})(i) : i;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var jt;
const mt = window, Gn = mt.trustedTypes, rs = Gn ? Gn.emptyScript : "", Zn = mt.reactiveElementPolyfillSupport, rn = { toAttribute(i, e) {
  switch (e) {
    case Boolean:
      i = i ? rs : null;
      break;
    case Object:
    case Array:
      i = i == null ? i : JSON.stringify(i);
  }
  return i;
}, fromAttribute(i, e) {
  let t = i;
  switch (e) {
    case Boolean:
      t = i !== null;
      break;
    case Number:
      t = i === null ? null : Number(i);
      break;
    case Object:
    case Array:
      try {
        t = JSON.parse(i);
      } catch {
        t = null;
      }
  }
  return t;
} }, vi = (i, e) => e !== i && (e == e || i == i), Wt = { attribute: !0, type: String, converter: rn, reflect: !1, hasChanged: vi }, on = "finalized";
let Le = class extends HTMLElement {
  constructor() {
    super(), this._$Ei = /* @__PURE__ */ new Map(), this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
  }
  static addInitializer(e) {
    var t;
    this.finalize(), ((t = this.h) !== null && t !== void 0 ? t : this.h = []).push(e);
  }
  static get observedAttributes() {
    this.finalize();
    const e = [];
    return this.elementProperties.forEach((t, n) => {
      const s = this._$Ep(n, t);
      s !== void 0 && (this._$Ev.set(s, n), e.push(s));
    }), e;
  }
  static createProperty(e, t = Wt) {
    if (t.state && (t.attribute = !1), this.finalize(), this.elementProperties.set(e, t), !t.noAccessor && !this.prototype.hasOwnProperty(e)) {
      const n = typeof e == "symbol" ? Symbol() : "__" + e, s = this.getPropertyDescriptor(e, n, t);
      s !== void 0 && Object.defineProperty(this.prototype, e, s);
    }
  }
  static getPropertyDescriptor(e, t, n) {
    return { get() {
      return this[t];
    }, set(s) {
      const r = this[e];
      this[t] = s, this.requestUpdate(e, r, n);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(e) {
    return this.elementProperties.get(e) || Wt;
  }
  static finalize() {
    if (this.hasOwnProperty(on))
      return !1;
    this[on] = !0;
    const e = Object.getPrototypeOf(this);
    if (e.finalize(), e.h !== void 0 && (this.h = [...e.h]), this.elementProperties = new Map(e.elementProperties), this._$Ev = /* @__PURE__ */ new Map(), this.hasOwnProperty("properties")) {
      const t = this.properties, n = [...Object.getOwnPropertyNames(t), ...Object.getOwnPropertySymbols(t)];
      for (const s of n)
        this.createProperty(s, t[s]);
    }
    return this.elementStyles = this.finalizeStyles(this.styles), !0;
  }
  static finalizeStyles(e) {
    const t = [];
    if (Array.isArray(e)) {
      const n = new Set(e.flat(1 / 0).reverse());
      for (const s of n)
        t.unshift(Wn(s));
    } else
      e !== void 0 && t.push(Wn(e));
    return t;
  }
  static _$Ep(e, t) {
    const n = t.attribute;
    return n === !1 ? void 0 : typeof n == "string" ? n : typeof e == "string" ? e.toLowerCase() : void 0;
  }
  _$Eu() {
    var e;
    this._$E_ = new Promise((t) => this.enableUpdating = t), this._$AL = /* @__PURE__ */ new Map(), this._$Eg(), this.requestUpdate(), (e = this.constructor.h) === null || e === void 0 || e.forEach((t) => t(this));
  }
  addController(e) {
    var t, n;
    ((t = this._$ES) !== null && t !== void 0 ? t : this._$ES = []).push(e), this.renderRoot !== void 0 && this.isConnected && ((n = e.hostConnected) === null || n === void 0 || n.call(e));
  }
  removeController(e) {
    var t;
    (t = this._$ES) === null || t === void 0 || t.splice(this._$ES.indexOf(e) >>> 0, 1);
  }
  _$Eg() {
    this.constructor.elementProperties.forEach((e, t) => {
      this.hasOwnProperty(t) && (this._$Ei.set(t, this[t]), delete this[t]);
    });
  }
  createRenderRoot() {
    var e;
    const t = (e = this.shadowRoot) !== null && e !== void 0 ? e : this.attachShadow(this.constructor.shadowRootOptions);
    return ss(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    var e;
    this.renderRoot === void 0 && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (e = this._$ES) === null || e === void 0 || e.forEach((t) => {
      var n;
      return (n = t.hostConnected) === null || n === void 0 ? void 0 : n.call(t);
    });
  }
  enableUpdating(e) {
  }
  disconnectedCallback() {
    var e;
    (e = this._$ES) === null || e === void 0 || e.forEach((t) => {
      var n;
      return (n = t.hostDisconnected) === null || n === void 0 ? void 0 : n.call(t);
    });
  }
  attributeChangedCallback(e, t, n) {
    this._$AK(e, n);
  }
  _$EO(e, t, n = Wt) {
    var s;
    const r = this.constructor._$Ep(e, n);
    if (r !== void 0 && n.reflect === !0) {
      const o = (((s = n.converter) === null || s === void 0 ? void 0 : s.toAttribute) !== void 0 ? n.converter : rn).toAttribute(t, n.type);
      this._$El = e, o == null ? this.removeAttribute(r) : this.setAttribute(r, o), this._$El = null;
    }
  }
  _$AK(e, t) {
    var n;
    const s = this.constructor, r = s._$Ev.get(e);
    if (r !== void 0 && this._$El !== r) {
      const o = s.getPropertyOptions(r), c = typeof o.converter == "function" ? { fromAttribute: o.converter } : ((n = o.converter) === null || n === void 0 ? void 0 : n.fromAttribute) !== void 0 ? o.converter : rn;
      this._$El = r, this[r] = c.fromAttribute(t, o.type), this._$El = null;
    }
  }
  requestUpdate(e, t, n) {
    let s = !0;
    e !== void 0 && (((n = n || this.constructor.getPropertyOptions(e)).hasChanged || vi)(this[e], t) ? (this._$AL.has(e) || this._$AL.set(e, t), n.reflect === !0 && this._$El !== e && (this._$EC === void 0 && (this._$EC = /* @__PURE__ */ new Map()), this._$EC.set(e, n))) : s = !1), !this.isUpdatePending && s && (this._$E_ = this._$Ej());
  }
  async _$Ej() {
    this.isUpdatePending = !0;
    try {
      await this._$E_;
    } catch (t) {
      Promise.reject(t);
    }
    const e = this.scheduleUpdate();
    return e != null && await e, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var e;
    if (!this.isUpdatePending)
      return;
    this.hasUpdated, this._$Ei && (this._$Ei.forEach((s, r) => this[r] = s), this._$Ei = void 0);
    let t = !1;
    const n = this._$AL;
    try {
      t = this.shouldUpdate(n), t ? (this.willUpdate(n), (e = this._$ES) === null || e === void 0 || e.forEach((s) => {
        var r;
        return (r = s.hostUpdate) === null || r === void 0 ? void 0 : r.call(s);
      }), this.update(n)) : this._$Ek();
    } catch (s) {
      throw t = !1, this._$Ek(), s;
    }
    t && this._$AE(n);
  }
  willUpdate(e) {
  }
  _$AE(e) {
    var t;
    (t = this._$ES) === null || t === void 0 || t.forEach((n) => {
      var s;
      return (s = n.hostUpdated) === null || s === void 0 ? void 0 : s.call(n);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(e)), this.updated(e);
  }
  _$Ek() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$E_;
  }
  shouldUpdate(e) {
    return !0;
  }
  update(e) {
    this._$EC !== void 0 && (this._$EC.forEach((t, n) => this._$EO(n, this[n], t)), this._$EC = void 0), this._$Ek();
  }
  updated(e) {
  }
  firstUpdated(e) {
  }
};
Le[on] = !0, Le.elementProperties = /* @__PURE__ */ new Map(), Le.elementStyles = [], Le.shadowRootOptions = { mode: "open" }, Zn == null || Zn({ ReactiveElement: Le }), ((jt = mt.reactiveElementVersions) !== null && jt !== void 0 ? jt : mt.reactiveElementVersions = []).push("1.6.3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var Gt;
const _t = window, Oe = _t.trustedTypes, Xn = Oe ? Oe.createPolicy("lit-html", { createHTML: (i) => i }) : void 0, an = "$lit$", ce = `lit$${(Math.random() + "").slice(9)}$`, wi = "?" + ce, os = `<${wi}>`, we = document, Xe = () => we.createComment(""), Ye = (i) => i === null || typeof i != "object" && typeof i != "function", yi = Array.isArray, as = (i) => yi(i) || typeof (i == null ? void 0 : i[Symbol.iterator]) == "function", Zt = `[ 	
\f\r]`, Fe = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, Yn = /-->/g, Qn = />/g, be = RegExp(`>|${Zt}(?:([^\\s"'>=/]+)(${Zt}*=${Zt}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), Kn = /'/g, Jn = /"/g, xi = /^(?:script|style|textarea|title)$/i, ls = (i) => (e, ...t) => ({ _$litType$: i, strings: e, values: t }), w = ls(1), ye = Symbol.for("lit-noChange"), D = Symbol.for("lit-nothing"), ei = /* @__PURE__ */ new WeakMap(), ve = we.createTreeWalker(we, 129, null, !1);
function Ti(i, e) {
  if (!Array.isArray(i) || !i.hasOwnProperty("raw"))
    throw Error("invalid template strings array");
  return Xn !== void 0 ? Xn.createHTML(e) : e;
}
const cs = (i, e) => {
  const t = i.length - 1, n = [];
  let s, r = e === 2 ? "<svg>" : "", o = Fe;
  for (let c = 0; c < t; c++) {
    const l = i[c];
    let h, p, f = -1, u = 0;
    for (; u < l.length && (o.lastIndex = u, p = o.exec(l), p !== null); )
      u = o.lastIndex, o === Fe ? p[1] === "!--" ? o = Yn : p[1] !== void 0 ? o = Qn : p[2] !== void 0 ? (xi.test(p[2]) && (s = RegExp("</" + p[2], "g")), o = be) : p[3] !== void 0 && (o = be) : o === be ? p[0] === ">" ? (o = s ?? Fe, f = -1) : p[1] === void 0 ? f = -2 : (f = o.lastIndex - p[2].length, h = p[1], o = p[3] === void 0 ? be : p[3] === '"' ? Jn : Kn) : o === Jn || o === Kn ? o = be : o === Yn || o === Qn ? o = Fe : (o = be, s = void 0);
    const _ = o === be && i[c + 1].startsWith("/>") ? " " : "";
    r += o === Fe ? l + os : f >= 0 ? (n.push(h), l.slice(0, f) + an + l.slice(f) + ce + _) : l + ce + (f === -2 ? (n.push(void 0), c) : _);
  }
  return [Ti(i, r + (i[t] || "<?>") + (e === 2 ? "</svg>" : "")), n];
};
class Qe {
  constructor({ strings: e, _$litType$: t }, n) {
    let s;
    this.parts = [];
    let r = 0, o = 0;
    const c = e.length - 1, l = this.parts, [h, p] = cs(e, t);
    if (this.el = Qe.createElement(h, n), ve.currentNode = this.el.content, t === 2) {
      const f = this.el.content, u = f.firstChild;
      u.remove(), f.append(...u.childNodes);
    }
    for (; (s = ve.nextNode()) !== null && l.length < c; ) {
      if (s.nodeType === 1) {
        if (s.hasAttributes()) {
          const f = [];
          for (const u of s.getAttributeNames())
            if (u.endsWith(an) || u.startsWith(ce)) {
              const _ = p[o++];
              if (f.push(u), _ !== void 0) {
                const C = s.getAttribute(_.toLowerCase() + an).split(ce), E = /([.?@])?(.*)/.exec(_);
                l.push({ type: 1, index: r, name: E[2], strings: C, ctor: E[1] === "." ? ps : E[1] === "?" ? us : E[1] === "@" ? fs : Ct });
              } else
                l.push({ type: 6, index: r });
            }
          for (const u of f)
            s.removeAttribute(u);
        }
        if (xi.test(s.tagName)) {
          const f = s.textContent.split(ce), u = f.length - 1;
          if (u > 0) {
            s.textContent = Oe ? Oe.emptyScript : "";
            for (let _ = 0; _ < u; _++)
              s.append(f[_], Xe()), ve.nextNode(), l.push({ type: 2, index: ++r });
            s.append(f[u], Xe());
          }
        }
      } else if (s.nodeType === 8)
        if (s.data === wi)
          l.push({ type: 2, index: r });
        else {
          let f = -1;
          for (; (f = s.data.indexOf(ce, f + 1)) !== -1; )
            l.push({ type: 7, index: r }), f += ce.length - 1;
        }
      r++;
    }
  }
  static createElement(e, t) {
    const n = we.createElement("template");
    return n.innerHTML = e, n;
  }
}
function De(i, e, t = i, n) {
  var s, r, o, c;
  if (e === ye)
    return e;
  let l = n !== void 0 ? (s = t._$Co) === null || s === void 0 ? void 0 : s[n] : t._$Cl;
  const h = Ye(e) ? void 0 : e._$litDirective$;
  return (l == null ? void 0 : l.constructor) !== h && ((r = l == null ? void 0 : l._$AO) === null || r === void 0 || r.call(l, !1), h === void 0 ? l = void 0 : (l = new h(i), l._$AT(i, t, n)), n !== void 0 ? ((o = (c = t)._$Co) !== null && o !== void 0 ? o : c._$Co = [])[n] = l : t._$Cl = l), l !== void 0 && (e = De(i, l._$AS(i, e.values), l, n)), e;
}
class hs {
  constructor(e, t) {
    this._$AV = [], this._$AN = void 0, this._$AD = e, this._$AM = t;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(e) {
    var t;
    const { el: { content: n }, parts: s } = this._$AD, r = ((t = e == null ? void 0 : e.creationScope) !== null && t !== void 0 ? t : we).importNode(n, !0);
    ve.currentNode = r;
    let o = ve.nextNode(), c = 0, l = 0, h = s[0];
    for (; h !== void 0; ) {
      if (c === h.index) {
        let p;
        h.type === 2 ? p = new nt(o, o.nextSibling, this, e) : h.type === 1 ? p = new h.ctor(o, h.name, h.strings, this, e) : h.type === 6 && (p = new gs(o, this, e)), this._$AV.push(p), h = s[++l];
      }
      c !== (h == null ? void 0 : h.index) && (o = ve.nextNode(), c++);
    }
    return ve.currentNode = we, r;
  }
  v(e) {
    let t = 0;
    for (const n of this._$AV)
      n !== void 0 && (n.strings !== void 0 ? (n._$AI(e, n, t), t += n.strings.length - 2) : n._$AI(e[t])), t++;
  }
}
class nt {
  constructor(e, t, n, s) {
    var r;
    this.type = 2, this._$AH = D, this._$AN = void 0, this._$AA = e, this._$AB = t, this._$AM = n, this.options = s, this._$Cp = (r = s == null ? void 0 : s.isConnected) === null || r === void 0 || r;
  }
  get _$AU() {
    var e, t;
    return (t = (e = this._$AM) === null || e === void 0 ? void 0 : e._$AU) !== null && t !== void 0 ? t : this._$Cp;
  }
  get parentNode() {
    let e = this._$AA.parentNode;
    const t = this._$AM;
    return t !== void 0 && (e == null ? void 0 : e.nodeType) === 11 && (e = t.parentNode), e;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(e, t = this) {
    e = De(this, e, t), Ye(e) ? e === D || e == null || e === "" ? (this._$AH !== D && this._$AR(), this._$AH = D) : e !== this._$AH && e !== ye && this._(e) : e._$litType$ !== void 0 ? this.g(e) : e.nodeType !== void 0 ? this.$(e) : as(e) ? this.T(e) : this._(e);
  }
  k(e) {
    return this._$AA.parentNode.insertBefore(e, this._$AB);
  }
  $(e) {
    this._$AH !== e && (this._$AR(), this._$AH = this.k(e));
  }
  _(e) {
    this._$AH !== D && Ye(this._$AH) ? this._$AA.nextSibling.data = e : this.$(we.createTextNode(e)), this._$AH = e;
  }
  g(e) {
    var t;
    const { values: n, _$litType$: s } = e, r = typeof s == "number" ? this._$AC(e) : (s.el === void 0 && (s.el = Qe.createElement(Ti(s.h, s.h[0]), this.options)), s);
    if (((t = this._$AH) === null || t === void 0 ? void 0 : t._$AD) === r)
      this._$AH.v(n);
    else {
      const o = new hs(r, this), c = o.u(this.options);
      o.v(n), this.$(c), this._$AH = o;
    }
  }
  _$AC(e) {
    let t = ei.get(e.strings);
    return t === void 0 && ei.set(e.strings, t = new Qe(e)), t;
  }
  T(e) {
    yi(this._$AH) || (this._$AH = [], this._$AR());
    const t = this._$AH;
    let n, s = 0;
    for (const r of e)
      s === t.length ? t.push(n = new nt(this.k(Xe()), this.k(Xe()), this, this.options)) : n = t[s], n._$AI(r), s++;
    s < t.length && (this._$AR(n && n._$AB.nextSibling, s), t.length = s);
  }
  _$AR(e = this._$AA.nextSibling, t) {
    var n;
    for ((n = this._$AP) === null || n === void 0 || n.call(this, !1, !0, t); e && e !== this._$AB; ) {
      const s = e.nextSibling;
      e.remove(), e = s;
    }
  }
  setConnected(e) {
    var t;
    this._$AM === void 0 && (this._$Cp = e, (t = this._$AP) === null || t === void 0 || t.call(this, e));
  }
}
class Ct {
  constructor(e, t, n, s, r) {
    this.type = 1, this._$AH = D, this._$AN = void 0, this.element = e, this.name = t, this._$AM = s, this.options = r, n.length > 2 || n[0] !== "" || n[1] !== "" ? (this._$AH = Array(n.length - 1).fill(new String()), this.strings = n) : this._$AH = D;
  }
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(e, t = this, n, s) {
    const r = this.strings;
    let o = !1;
    if (r === void 0)
      e = De(this, e, t, 0), o = !Ye(e) || e !== this._$AH && e !== ye, o && (this._$AH = e);
    else {
      const c = e;
      let l, h;
      for (e = r[0], l = 0; l < r.length - 1; l++)
        h = De(this, c[n + l], t, l), h === ye && (h = this._$AH[l]), o || (o = !Ye(h) || h !== this._$AH[l]), h === D ? e = D : e !== D && (e += (h ?? "") + r[l + 1]), this._$AH[l] = h;
    }
    o && !s && this.j(e);
  }
  j(e) {
    e === D ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, e ?? "");
  }
}
class ps extends Ct {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(e) {
    this.element[this.name] = e === D ? void 0 : e;
  }
}
const ds = Oe ? Oe.emptyScript : "";
class us extends Ct {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(e) {
    e && e !== D ? this.element.setAttribute(this.name, ds) : this.element.removeAttribute(this.name);
  }
}
class fs extends Ct {
  constructor(e, t, n, s, r) {
    super(e, t, n, s, r), this.type = 5;
  }
  _$AI(e, t = this) {
    var n;
    if ((e = (n = De(this, e, t, 0)) !== null && n !== void 0 ? n : D) === ye)
      return;
    const s = this._$AH, r = e === D && s !== D || e.capture !== s.capture || e.once !== s.once || e.passive !== s.passive, o = e !== D && (s === D || r);
    r && this.element.removeEventListener(this.name, this, s), o && this.element.addEventListener(this.name, this, e), this._$AH = e;
  }
  handleEvent(e) {
    var t, n;
    typeof this._$AH == "function" ? this._$AH.call((n = (t = this.options) === null || t === void 0 ? void 0 : t.host) !== null && n !== void 0 ? n : this.element, e) : this._$AH.handleEvent(e);
  }
}
class gs {
  constructor(e, t, n) {
    this.element = e, this.type = 6, this._$AN = void 0, this._$AM = t, this.options = n;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(e) {
    De(this, e);
  }
}
const ti = _t.litHtmlPolyfillSupport;
ti == null || ti(Qe, nt), ((Gt = _t.litHtmlVersions) !== null && Gt !== void 0 ? Gt : _t.litHtmlVersions = []).push("2.8.0");
const ms = (i, e, t) => {
  var n, s;
  const r = (n = t == null ? void 0 : t.renderBefore) !== null && n !== void 0 ? n : e;
  let o = r._$litPart$;
  if (o === void 0) {
    const c = (s = t == null ? void 0 : t.renderBefore) !== null && s !== void 0 ? s : null;
    r._$litPart$ = o = new nt(e.insertBefore(Xe(), c), c, void 0, t ?? {});
  }
  return o._$AI(i), o;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var Xt, Yt;
class F extends Le {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var e, t;
    const n = super.createRenderRoot();
    return (e = (t = this.renderOptions).renderBefore) !== null && e !== void 0 || (t.renderBefore = n.firstChild), n;
  }
  update(e) {
    const t = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Do = ms(t, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var e;
    super.connectedCallback(), (e = this._$Do) === null || e === void 0 || e.setConnected(!0);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this._$Do) === null || e === void 0 || e.setConnected(!1);
  }
  render() {
    return ye;
  }
}
F.finalized = !0, F._$litElement$ = !0, (Xt = globalThis.litElementHydrateSupport) === null || Xt === void 0 || Xt.call(globalThis, { LitElement: F });
const ni = globalThis.litElementPolyfillSupport;
ni == null || ni({ LitElement: F });
((Yt = globalThis.litElementVersions) !== null && Yt !== void 0 ? Yt : globalThis.litElementVersions = []).push("3.3.3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const J = (i) => (e) => typeof e == "function" ? ((t, n) => (customElements.define(t, n), n))(i, e) : ((t, n) => {
  const { kind: s, elements: r } = n;
  return { kind: s, elements: r, finisher(o) {
    customElements.define(t, o);
  } };
})(i, e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const _s = (i, e) => e.kind === "method" && e.descriptor && !("value" in e.descriptor) ? { ...e, finisher(t) {
  t.createProperty(e.key, i);
} } : { kind: "field", key: Symbol(), placement: "own", descriptor: {}, originalKey: e.key, initializer() {
  typeof e.initializer == "function" && (this[e.key] = e.initializer.call(this));
}, finisher(t) {
  t.createProperty(e.key, i);
} }, bs = (i, e, t) => {
  e.constructor.createProperty(t, i);
};
function x(i) {
  return (e, t) => t !== void 0 ? bs(i, e, t) : _s(i, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function Q(i) {
  return x({ ...i, state: !0 });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const vs = ({ finisher: i, descriptor: e }) => (t, n) => {
  var s;
  if (n === void 0) {
    const r = (s = t.originalKey) !== null && s !== void 0 ? s : t.key, o = e != null ? { kind: "method", placement: "prototype", key: r, descriptor: e(t.key) } : { ...t, key: r };
    return i != null && (o.finisher = function(c) {
      i(c, r);
    }), o;
  }
  {
    const r = t.constructor;
    e !== void 0 && Object.defineProperty(t, n, e(n)), i == null || i(r, n);
  }
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function ki(i, e) {
  return vs({ descriptor: (t) => {
    const n = { get() {
      var s, r;
      return (r = (s = this.renderRoot) === null || s === void 0 ? void 0 : s.querySelector(i)) !== null && r !== void 0 ? r : null;
    }, enumerable: !0, configurable: !0 };
    if (e) {
      const s = typeof t == "symbol" ? Symbol() : "__" + t;
      n.get = function() {
        var r, o;
        return this[s] === void 0 && (this[s] = (o = (r = this.renderRoot) === null || r === void 0 ? void 0 : r.querySelector(i)) !== null && o !== void 0 ? o : null), this[s];
      };
    }
    return n;
  } });
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var Qt;
((Qt = window.HTMLSlotElement) === null || Qt === void 0 ? void 0 : Qt.prototype.assignedElements) != null;
const ws = oe`
  .headline {
    color: var(--text-color);
    font-size: var(--font-r-large);
    padding: 0;
    margin: var(--d-small) 0 var(--d-large);

    @media (min-width: 1024px) {
      font-size: var(--font-r-base);
      text-align: center;
    }
  }
  [role='button'] {
    text-decoration: none;
    color: var(--text-color);
    display: block;
    font-size: var(--font-rel-base);
  }
  .teaser-list {
    list-style-type: none;
    padding: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 80px;
  }
  .teaser-list.always-row {
    text-align: left;
  }
  .teaser-list:not(.always-row) {
    @media (min-width: 1024px) {
      flex-direction: row;
    }
  }
  .teaser-list-item {
    padding: var(--d-small);
    border-radius: var(--radius-base);
    background: var(--c-white);
    margin: var(--d-xsmall);
    color: var(--text-color);
    justify-content: space-evenly;
    box-shadow: var(--shadow);
    border: var(--border-base) solid transparent;

    @media (min-width: 768px) {
      min-height: 100px;
    }
  }
  .teaser-list-item a {
    padding-top: 16px;
  }
  .teaser-list-item:hover,
  .teaser-list-item:focus {
    color: var(--c-accent-dark);
    background: var(--c-secondary);
    transition: all 0.3s ease-in-out;
    border-color: var(--c-accent-high);
  }
  .teaser-list-item .teaser-click-label {
    color: var(--c-accent-high);
    font-weight: bold;
    display: block;
    margin-top: 20px;
    text-decoration: underline;
  }
`;
var ys = Object.defineProperty, xs = Object.getOwnPropertyDescriptor, He = (i, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? xs(e, t) : e, r = i.length - 1, o; r >= 0; r--)
    (o = i[r]) && (s = (n ? o(e, t, s) : o(s)) || s);
  return n && s && ys(e, t, s), s;
};
let he = class extends F {
  constructor() {
    super(...arguments), this.teasers = [], this.heading = void 0, this.actionLabel = void 0, this.alwaysRow = !1, this.clickable = !1;
  }
  // Handle the click on a default prompt
  handleTeaserClick(i, e) {
    e == null || e.preventDefault();
    const t = new CustomEvent("teaser-click", {
      detail: {
        question: i.description
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(t);
  }
  renderClickableTeaser(i) {
    return w`
      <a
        role="button"
        href="#"
        data-testid="default-question"
        @click="${(e) => this.handleTeaserClick(i, e)}"
      >
        ${i.description}
        <span class="teaser-click-label">${this.actionLabel}</span>
      </a>
    `;
  }
  render() {
    return w`
      <div class="teaser-list-container">
        ${this.heading ? w`<h1 class="headline">${this.heading}</h1>` : ""}
        <ul class="teaser-list ${this.alwaysRow ? "always-row" : ""}">
          ${this.teasers.map(
      (i) => w`
              <li class="teaser-list-item">
                ${this.clickable ? this.renderClickableTeaser(i) : i.description}
              </li>
            `
    )}
        </ul>
      </div>
    `;
  }
};
he.styles = [ws];
He([
  x({ type: Array })
], he.prototype, "teasers", 2);
He([
  x({ type: String })
], he.prototype, "heading", 2);
He([
  x({ type: String })
], he.prototype, "actionLabel", 2);
He([
  x({ type: Boolean })
], he.prototype, "alwaysRow", 2);
He([
  x({ type: Boolean })
], he.prototype, "clickable", 2);
he = He([
  J("teaser-list-component")
], he);
const Ts = oe`
  .tab-component__list {
    list-style-type: none;
    display: flex;
    box-shadow: var(--shadow);
    border-radius: var(--radius-base);
    padding: var(--d-xsmall);
    width: 450px;
    margin: 0 auto;
    justify-content: space-evenly;
  }
  .tab-component__listItem {
    width: 33%;
    text-align: center;
  }
  .tab-component__link.active {
    background: var(--c-accent-dark);
    color: var(--c-white);
  }
  .tab-component__link:not(.active):hover {
    background: var(--c-light-gray);
    cursor: pointer;
  }
  .tab-component__link {
    border-bottom: 4px solid transparent;
    border-radius: var(--radius-small);
    text-decoration: none;
    color: var(--text-color);
    font-weight: bold;
    font-size: var(--font-small);
    cursor: pointer;
    display: block;
    padding: var(--d-small);
  }
  .tab-component__content {
    position: relative;
  }
  .tab-component__tab {
    position: absolute;
    top: 0;
    left: 30px;
    display: none;
    width: 100%;
    @media (max-width: 1024px) {
      position: relative;
      left: 0;
    }
  }
  .tab-component__tab.active {
    display: block;
  }
`;
var ks = Object.defineProperty, Cs = Object.getOwnPropertyDescriptor, mn = (i, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? Cs(e, t) : e, r = i.length - 1, o; r >= 0; r--)
    (o = i[r]) && (s = (n ? o(e, t, s) : o(s)) || s);
  return n && s && ks(e, t, s), s;
};
let Ke = class extends F {
  constructor() {
    super(...arguments), this.tabs = [], this.selectedTabId = void 0;
  }
  activateTab(i) {
    i.preventDefault();
    const e = i.target.id;
    this.selectedTabId = e;
  }
  renderTabListItem(i, e) {
    return w`
      <li class="tab-component__listItem">
        <a
          id="${i.id}"
          class="tab-component__link ${e ? "active" : ""}"
          role="tab"
          href="#"
          aria-selected="${e}"
          aria-hidden="${!e}"
          aria-controls="tabpanel-${i.id}"
          @click="${(t) => this.activateTab(t)}"
          title="${i.label}"
        >
          ${i.label}
        </a>
      </li>
    `;
  }
  renderTabContent(i, e) {
    return w`
      <div
        id="tabpanel-${i.id}"
        class="tab-component__tab ${e ? "active" : ""}"
        role="tabpanel"
        tabindex="${e ? "0" : "-1"}"
        aria-labelledby="${i.id}"
      >
        <slot name="${i.id}"></slot>
      </div>
    `;
  }
  render() {
    return w`
      <div class="tab-component">
        <nav>
          <ul class="tab-component__list" role="tablist">
            ${this.tabs.map((i) => this.renderTabListItem(i, i.id === this.selectedTabId))}
          </ul>
        </nav>
        <div class="tab-component__content">
          ${this.tabs.map((i) => this.renderTabContent(i, i.id === this.selectedTabId))}
        </div>
      </div>
    `;
  }
};
Ke.styles = [Ts];
mn([
  x({ type: Array })
], Ke.prototype, "tabs", 2);
mn([
  x({ type: String })
], Ke.prototype, "selectedTabId", 2);
Ke = mn([
  J("tab-component")
], Ke);
/*! @license DOMPurify 3.0.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.0.6/LICENSE */
const {
  entries: Ci,
  setPrototypeOf: ii,
  isFrozen: As,
  getPrototypeOf: Es,
  getOwnPropertyDescriptor: Ai
} = Object;
let {
  freeze: V,
  seal: K,
  create: Ei
} = Object, {
  apply: ln,
  construct: cn
} = typeof Reflect < "u" && Reflect;
V || (V = function(e) {
  return e;
});
K || (K = function(e) {
  return e;
});
ln || (ln = function(e, t, n) {
  return e.apply(t, n);
});
cn || (cn = function(e, t) {
  return new e(...t);
});
const ct = Y(Array.prototype.forEach), si = Y(Array.prototype.pop), Ve = Y(Array.prototype.push), gt = Y(String.prototype.toLowerCase), Kt = Y(String.prototype.toString), $s = Y(String.prototype.match), je = Y(String.prototype.replace), Ss = Y(String.prototype.indexOf), Rs = Y(String.prototype.trim), Z = Y(RegExp.prototype.test), We = Is(TypeError);
function Y(i) {
  return function(e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
      n[s - 1] = arguments[s];
    return ln(i, e, n);
  };
}
function Is(i) {
  return function() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return cn(i, t);
  };
}
function y(i, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : gt;
  ii && ii(i, null);
  let n = e.length;
  for (; n--; ) {
    let s = e[n];
    if (typeof s == "string") {
      const r = t(s);
      r !== s && (As(e) || (e[n] = r), s = r);
    }
    i[s] = !0;
  }
  return i;
}
function Ie(i) {
  const e = Ei(null);
  for (const [t, n] of Ci(i))
    Ai(i, t) !== void 0 && (e[t] = n);
  return e;
}
function ht(i, e) {
  for (; i !== null; ) {
    const n = Ai(i, e);
    if (n) {
      if (n.get)
        return Y(n.get);
      if (typeof n.value == "function")
        return Y(n.value);
    }
    i = Es(i);
  }
  function t(n) {
    return console.warn("fallback value for", n), null;
  }
  return t;
}
const ri = V(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Jt = V(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), en = V(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Ls = V(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), tn = V(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Os = V(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), oi = V(["#text"]), ai = V(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]), nn = V(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), li = V(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), pt = V(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Ds = K(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Ps = K(/<%[\w\W]*|[\w\W]*%>/gm), Ns = K(/\${[\w\W]*}/gm), Ms = K(/^data-[\-\w.\u00B7-\uFFFF]/), Hs = K(/^aria-[\-\w]+$/), $i = K(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Us = K(/^(?:\w+script|data):/i), zs = K(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Si = K(/^html$/i);
var ci = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR: Ds,
  ERB_EXPR: Ps,
  TMPLIT_EXPR: Ns,
  DATA_ATTR: Ms,
  ARIA_ATTR: Hs,
  IS_ALLOWED_URI: $i,
  IS_SCRIPT_OR_DATA: Us,
  ATTR_WHITESPACE: zs,
  DOCTYPE_NAME: Si
});
const Bs = function() {
  return typeof window > "u" ? null : window;
}, qs = function(e, t) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let n = null;
  const s = "data-tt-policy-suffix";
  t && t.hasAttribute(s) && (n = t.getAttribute(s));
  const r = "dompurify" + (n ? "#" + n : "");
  try {
    return e.createPolicy(r, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + r + " could not be created."), null;
  }
};
function Ri() {
  let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Bs();
  const e = (b) => Ri(b);
  if (e.version = "3.0.6", e.removed = [], !i || !i.document || i.document.nodeType !== 9)
    return e.isSupported = !1, e;
  let {
    document: t
  } = i;
  const n = t, s = n.currentScript, {
    DocumentFragment: r,
    HTMLTemplateElement: o,
    Node: c,
    Element: l,
    NodeFilter: h,
    NamedNodeMap: p = i.NamedNodeMap || i.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: u,
    trustedTypes: _
  } = i, C = l.prototype, E = ht(C, "cloneNode"), L = ht(C, "nextSibling"), G = ht(C, "childNodes"), ee = ht(C, "parentNode");
  if (typeof o == "function") {
    const b = t.createElement("template");
    b.content && b.content.ownerDocument && (t = b.content.ownerDocument);
  }
  let S, $ = "";
  const {
    implementation: N,
    createNodeIterator: ke,
    createDocumentFragment: ue,
    getElementsByTagName: zi
  } = t, {
    importNode: Bi
  } = n;
  let te = {};
  e.isSupported = typeof Ci == "function" && typeof ee == "function" && N && N.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: Rt,
    ERB_EXPR: It,
    TMPLIT_EXPR: Lt,
    DATA_ATTR: qi,
    ARIA_ATTR: Fi,
    IS_SCRIPT_OR_DATA: Vi,
    ATTR_WHITESPACE: wn
  } = ci;
  let {
    IS_ALLOWED_URI: yn
  } = ci, M = null;
  const xn = y({}, [...ri, ...Jt, ...en, ...tn, ...oi]);
  let H = null;
  const Tn = y({}, [...ai, ...nn, ...li, ...pt]);
  let O = Object.seal(Ei(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), ze = null, Ot = null, kn = !0, Dt = !0, Cn = !1, An = !0, Ce = !1, fe = !1, Pt = !1, Nt = !1, Ae = !1, it = !1, st = !1, En = !0, $n = !1;
  const ji = "user-content-";
  let Mt = !0, Be = !1, Ee = {}, $e = null;
  const Sn = y({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Rn = null;
  const In = y({}, ["audio", "video", "img", "source", "image", "track"]);
  let Ht = null;
  const Ln = y({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), rt = "http://www.w3.org/1998/Math/MathML", ot = "http://www.w3.org/2000/svg", ae = "http://www.w3.org/1999/xhtml";
  let Se = ae, Ut = !1, zt = null;
  const Wi = y({}, [rt, ot, ae], Kt);
  let ge = null;
  const Gi = ["application/xhtml+xml", "text/html"], Zi = "text/html";
  let U = null, Re = null;
  const Xi = t.createElement("form"), On = function(a) {
    return a instanceof RegExp || a instanceof Function;
  }, Bt = function() {
    let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Re && Re === a)) {
      if ((!a || typeof a != "object") && (a = {}), a = Ie(a), ge = // eslint-disable-next-line unicorn/prefer-includes
      Gi.indexOf(a.PARSER_MEDIA_TYPE) === -1 ? ge = Zi : ge = a.PARSER_MEDIA_TYPE, U = ge === "application/xhtml+xml" ? Kt : gt, M = "ALLOWED_TAGS" in a ? y({}, a.ALLOWED_TAGS, U) : xn, H = "ALLOWED_ATTR" in a ? y({}, a.ALLOWED_ATTR, U) : Tn, zt = "ALLOWED_NAMESPACES" in a ? y({}, a.ALLOWED_NAMESPACES, Kt) : Wi, Ht = "ADD_URI_SAFE_ATTR" in a ? y(
        Ie(Ln),
        // eslint-disable-line indent
        a.ADD_URI_SAFE_ATTR,
        // eslint-disable-line indent
        U
        // eslint-disable-line indent
      ) : Ln, Rn = "ADD_DATA_URI_TAGS" in a ? y(
        Ie(In),
        // eslint-disable-line indent
        a.ADD_DATA_URI_TAGS,
        // eslint-disable-line indent
        U
        // eslint-disable-line indent
      ) : In, $e = "FORBID_CONTENTS" in a ? y({}, a.FORBID_CONTENTS, U) : Sn, ze = "FORBID_TAGS" in a ? y({}, a.FORBID_TAGS, U) : {}, Ot = "FORBID_ATTR" in a ? y({}, a.FORBID_ATTR, U) : {}, Ee = "USE_PROFILES" in a ? a.USE_PROFILES : !1, kn = a.ALLOW_ARIA_ATTR !== !1, Dt = a.ALLOW_DATA_ATTR !== !1, Cn = a.ALLOW_UNKNOWN_PROTOCOLS || !1, An = a.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ce = a.SAFE_FOR_TEMPLATES || !1, fe = a.WHOLE_DOCUMENT || !1, Ae = a.RETURN_DOM || !1, it = a.RETURN_DOM_FRAGMENT || !1, st = a.RETURN_TRUSTED_TYPE || !1, Nt = a.FORCE_BODY || !1, En = a.SANITIZE_DOM !== !1, $n = a.SANITIZE_NAMED_PROPS || !1, Mt = a.KEEP_CONTENT !== !1, Be = a.IN_PLACE || !1, yn = a.ALLOWED_URI_REGEXP || $i, Se = a.NAMESPACE || ae, O = a.CUSTOM_ELEMENT_HANDLING || {}, a.CUSTOM_ELEMENT_HANDLING && On(a.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (O.tagNameCheck = a.CUSTOM_ELEMENT_HANDLING.tagNameCheck), a.CUSTOM_ELEMENT_HANDLING && On(a.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (O.attributeNameCheck = a.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), a.CUSTOM_ELEMENT_HANDLING && typeof a.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (O.allowCustomizedBuiltInElements = a.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Ce && (Dt = !1), it && (Ae = !0), Ee && (M = y({}, [...oi]), H = [], Ee.html === !0 && (y(M, ri), y(H, ai)), Ee.svg === !0 && (y(M, Jt), y(H, nn), y(H, pt)), Ee.svgFilters === !0 && (y(M, en), y(H, nn), y(H, pt)), Ee.mathMl === !0 && (y(M, tn), y(H, li), y(H, pt))), a.ADD_TAGS && (M === xn && (M = Ie(M)), y(M, a.ADD_TAGS, U)), a.ADD_ATTR && (H === Tn && (H = Ie(H)), y(H, a.ADD_ATTR, U)), a.ADD_URI_SAFE_ATTR && y(Ht, a.ADD_URI_SAFE_ATTR, U), a.FORBID_CONTENTS && ($e === Sn && ($e = Ie($e)), y($e, a.FORBID_CONTENTS, U)), Mt && (M["#text"] = !0), fe && y(M, ["html", "head", "body"]), M.table && (y(M, ["tbody"]), delete ze.tbody), a.TRUSTED_TYPES_POLICY) {
        if (typeof a.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw We('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof a.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw We('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        S = a.TRUSTED_TYPES_POLICY, $ = S.createHTML("");
      } else
        S === void 0 && (S = qs(_, s)), S !== null && typeof $ == "string" && ($ = S.createHTML(""));
      V && V(a), Re = a;
    }
  }, Dn = y({}, ["mi", "mo", "mn", "ms", "mtext"]), Pn = y({}, ["foreignobject", "desc", "title", "annotation-xml"]), Yi = y({}, ["title", "style", "font", "a", "script"]), at = y({}, Jt);
  y(at, en), y(at, Ls);
  const qt = y({}, tn);
  y(qt, Os);
  const Qi = function(a) {
    let d = ee(a);
    (!d || !d.tagName) && (d = {
      namespaceURI: Se,
      tagName: "template"
    });
    const m = gt(a.tagName), I = gt(d.tagName);
    return zt[a.namespaceURI] ? a.namespaceURI === ot ? d.namespaceURI === ae ? m === "svg" : d.namespaceURI === rt ? m === "svg" && (I === "annotation-xml" || Dn[I]) : !!at[m] : a.namespaceURI === rt ? d.namespaceURI === ae ? m === "math" : d.namespaceURI === ot ? m === "math" && Pn[I] : !!qt[m] : a.namespaceURI === ae ? d.namespaceURI === ot && !Pn[I] || d.namespaceURI === rt && !Dn[I] ? !1 : !qt[m] && (Yi[m] || !at[m]) : !!(ge === "application/xhtml+xml" && zt[a.namespaceURI]) : !1;
  }, me = function(a) {
    Ve(e.removed, {
      element: a
    });
    try {
      a.parentNode.removeChild(a);
    } catch {
      a.remove();
    }
  }, Ft = function(a, d) {
    try {
      Ve(e.removed, {
        attribute: d.getAttributeNode(a),
        from: d
      });
    } catch {
      Ve(e.removed, {
        attribute: null,
        from: d
      });
    }
    if (d.removeAttribute(a), a === "is" && !H[a])
      if (Ae || it)
        try {
          me(d);
        } catch {
        }
      else
        try {
          d.setAttribute(a, "");
        } catch {
        }
  }, Nn = function(a) {
    let d = null, m = null;
    if (Nt)
      a = "<remove></remove>" + a;
    else {
      const q = $s(a, /^[\r\n\t ]+/);
      m = q && q[0];
    }
    ge === "application/xhtml+xml" && Se === ae && (a = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + a + "</body></html>");
    const I = S ? S.createHTML(a) : a;
    if (Se === ae)
      try {
        d = new u().parseFromString(I, ge);
      } catch {
      }
    if (!d || !d.documentElement) {
      d = N.createDocument(Se, "template", null);
      try {
        d.documentElement.innerHTML = Ut ? $ : I;
      } catch {
      }
    }
    const B = d.body || d.documentElement;
    return a && m && B.insertBefore(t.createTextNode(m), B.childNodes[0] || null), Se === ae ? zi.call(d, fe ? "html" : "body")[0] : fe ? d.documentElement : B;
  }, Mn = function(a) {
    return ke.call(
      a.ownerDocument || a,
      a,
      // eslint-disable-next-line no-bitwise
      h.SHOW_ELEMENT | h.SHOW_COMMENT | h.SHOW_TEXT,
      null
    );
  }, Ki = function(a) {
    return a instanceof f && (typeof a.nodeName != "string" || typeof a.textContent != "string" || typeof a.removeChild != "function" || !(a.attributes instanceof p) || typeof a.removeAttribute != "function" || typeof a.setAttribute != "function" || typeof a.namespaceURI != "string" || typeof a.insertBefore != "function" || typeof a.hasChildNodes != "function");
  }, Hn = function(a) {
    return typeof c == "function" && a instanceof c;
  }, le = function(a, d, m) {
    te[a] && ct(te[a], (I) => {
      I.call(e, d, m, Re);
    });
  }, Un = function(a) {
    let d = null;
    if (le("beforeSanitizeElements", a, null), Ki(a))
      return me(a), !0;
    const m = U(a.nodeName);
    if (le("uponSanitizeElement", a, {
      tagName: m,
      allowedTags: M
    }), a.hasChildNodes() && !Hn(a.firstElementChild) && Z(/<[/\w]/g, a.innerHTML) && Z(/<[/\w]/g, a.textContent))
      return me(a), !0;
    if (!M[m] || ze[m]) {
      if (!ze[m] && Bn(m) && (O.tagNameCheck instanceof RegExp && Z(O.tagNameCheck, m) || O.tagNameCheck instanceof Function && O.tagNameCheck(m)))
        return !1;
      if (Mt && !$e[m]) {
        const I = ee(a) || a.parentNode, B = G(a) || a.childNodes;
        if (B && I) {
          const q = B.length;
          for (let j = q - 1; j >= 0; --j)
            I.insertBefore(E(B[j], !0), L(a));
        }
      }
      return me(a), !0;
    }
    return a instanceof l && !Qi(a) || (m === "noscript" || m === "noembed" || m === "noframes") && Z(/<\/no(script|embed|frames)/i, a.innerHTML) ? (me(a), !0) : (Ce && a.nodeType === 3 && (d = a.textContent, ct([Rt, It, Lt], (I) => {
      d = je(d, I, " ");
    }), a.textContent !== d && (Ve(e.removed, {
      element: a.cloneNode()
    }), a.textContent = d)), le("afterSanitizeElements", a, null), !1);
  }, zn = function(a, d, m) {
    if (En && (d === "id" || d === "name") && (m in t || m in Xi))
      return !1;
    if (!(Dt && !Ot[d] && Z(qi, d))) {
      if (!(kn && Z(Fi, d))) {
        if (!H[d] || Ot[d]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Bn(a) && (O.tagNameCheck instanceof RegExp && Z(O.tagNameCheck, a) || O.tagNameCheck instanceof Function && O.tagNameCheck(a)) && (O.attributeNameCheck instanceof RegExp && Z(O.attributeNameCheck, d) || O.attributeNameCheck instanceof Function && O.attributeNameCheck(d)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            d === "is" && O.allowCustomizedBuiltInElements && (O.tagNameCheck instanceof RegExp && Z(O.tagNameCheck, m) || O.tagNameCheck instanceof Function && O.tagNameCheck(m)))
          )
            return !1;
        } else if (!Ht[d]) {
          if (!Z(yn, je(m, wn, ""))) {
            if (!((d === "src" || d === "xlink:href" || d === "href") && a !== "script" && Ss(m, "data:") === 0 && Rn[a])) {
              if (!(Cn && !Z(Vi, je(m, wn, "")))) {
                if (m)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Bn = function(a) {
    return a.indexOf("-") > 0;
  }, qn = function(a) {
    le("beforeSanitizeAttributes", a, null);
    const {
      attributes: d
    } = a;
    if (!d)
      return;
    const m = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: H
    };
    let I = d.length;
    for (; I--; ) {
      const B = d[I], {
        name: q,
        namespaceURI: j,
        value: _e
      } = B, qe = U(q);
      let W = q === "value" ? _e : Rs(_e);
      if (m.attrName = qe, m.attrValue = W, m.keepAttr = !0, m.forceKeepAttr = void 0, le("uponSanitizeAttribute", a, m), W = m.attrValue, m.forceKeepAttr || (Ft(q, a), !m.keepAttr))
        continue;
      if (!An && Z(/\/>/i, W)) {
        Ft(q, a);
        continue;
      }
      Ce && ct([Rt, It, Lt], (Vn) => {
        W = je(W, Vn, " ");
      });
      const Fn = U(a.nodeName);
      if (zn(Fn, qe, W)) {
        if ($n && (qe === "id" || qe === "name") && (Ft(q, a), W = ji + W), S && typeof _ == "object" && typeof _.getAttributeType == "function" && !j)
          switch (_.getAttributeType(Fn, qe)) {
            case "TrustedHTML": {
              W = S.createHTML(W);
              break;
            }
            case "TrustedScriptURL": {
              W = S.createScriptURL(W);
              break;
            }
          }
        try {
          j ? a.setAttributeNS(j, q, W) : a.setAttribute(q, W), si(e.removed);
        } catch {
        }
      }
    }
    le("afterSanitizeAttributes", a, null);
  }, Ji = function b(a) {
    let d = null;
    const m = Mn(a);
    for (le("beforeSanitizeShadowDOM", a, null); d = m.nextNode(); )
      le("uponSanitizeShadowNode", d, null), !Un(d) && (d.content instanceof r && b(d.content), qn(d));
    le("afterSanitizeShadowDOM", a, null);
  };
  return e.sanitize = function(b) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, d = null, m = null, I = null, B = null;
    if (Ut = !b, Ut && (b = "<!-->"), typeof b != "string" && !Hn(b))
      if (typeof b.toString == "function") {
        if (b = b.toString(), typeof b != "string")
          throw We("dirty is not a string, aborting");
      } else
        throw We("toString is not a function");
    if (!e.isSupported)
      return b;
    if (Pt || Bt(a), e.removed = [], typeof b == "string" && (Be = !1), Be) {
      if (b.nodeName) {
        const _e = U(b.nodeName);
        if (!M[_e] || ze[_e])
          throw We("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (b instanceof c)
      d = Nn("<!---->"), m = d.ownerDocument.importNode(b, !0), m.nodeType === 1 && m.nodeName === "BODY" || m.nodeName === "HTML" ? d = m : d.appendChild(m);
    else {
      if (!Ae && !Ce && !fe && // eslint-disable-next-line unicorn/prefer-includes
      b.indexOf("<") === -1)
        return S && st ? S.createHTML(b) : b;
      if (d = Nn(b), !d)
        return Ae ? null : st ? $ : "";
    }
    d && Nt && me(d.firstChild);
    const q = Mn(Be ? b : d);
    for (; I = q.nextNode(); )
      Un(I) || (I.content instanceof r && Ji(I.content), qn(I));
    if (Be)
      return b;
    if (Ae) {
      if (it)
        for (B = ue.call(d.ownerDocument); d.firstChild; )
          B.appendChild(d.firstChild);
      else
        B = d;
      return (H.shadowroot || H.shadowrootmode) && (B = Bi.call(n, B, !0)), B;
    }
    let j = fe ? d.outerHTML : d.innerHTML;
    return fe && M["!doctype"] && d.ownerDocument && d.ownerDocument.doctype && d.ownerDocument.doctype.name && Z(Si, d.ownerDocument.doctype.name) && (j = "<!DOCTYPE " + d.ownerDocument.doctype.name + `>
` + j), Ce && ct([Rt, It, Lt], (_e) => {
      j = je(j, _e, " ");
    }), S && st ? S.createHTML(j) : j;
  }, e.setConfig = function() {
    let b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Bt(b), Pt = !0;
  }, e.clearConfig = function() {
    Re = null, Pt = !1;
  }, e.isValidAttribute = function(b, a, d) {
    Re || Bt({});
    const m = U(b), I = U(a);
    return zn(m, I, d);
  }, e.addHook = function(b, a) {
    typeof a == "function" && (te[b] = te[b] || [], Ve(te[b], a));
  }, e.removeHook = function(b) {
    if (te[b])
      return si(te[b]);
  }, e.removeHooks = function(b) {
    te[b] && (te[b] = []);
  }, e.removeAllHooks = function() {
    te = {};
  }, e;
}
var hi = Ri();
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Fs = { ATTRIBUTE: 1, CHILD: 2, PROPERTY: 3, BOOLEAN_ATTRIBUTE: 4, EVENT: 5, ELEMENT: 6 }, Ii = (i) => (...e) => ({ _$litDirective$: i, values: e });
class Vs {
  constructor(e) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(e, t, n) {
    this._$Ct = e, this._$AM = t, this._$Ci = n;
  }
  _$AS(e, t) {
    return this.update(e, t);
  }
  update(e, t) {
    return this.render(...t);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class bt extends Vs {
  constructor(e) {
    if (super(e), this.et = D, e.type !== Fs.CHILD)
      throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(e) {
    if (e === D || e == null)
      return this.ft = void 0, this.et = e;
    if (e === ye)
      return e;
    if (typeof e != "string")
      throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (e === this.et)
      return this.ft;
    this.et = e;
    const t = [e];
    return t.raw = t, this.ft = { _$litType$: this.constructor.resultType, strings: t, values: [] };
  }
}
bt.directiveName = "unsafeHTML", bt.resultType = 1;
const vt = Ii(bt), T = {
  BOT_TYPING_EFFECT_INTERVAL: 50,
  // in ms
  // Is default prompts enabled?
  IS_DEFAULT_PROMPTS_ENABLED: !0,
  // Default prompts to display in the chat
  DISPLAY_DEFAULT_PROMPTS_BUTTON: "Not sure what to ask? Try our suggestions!",
  // This are the chat bubbles that will be displayed in the chat
  CHAT_MESSAGES: [],
  // This are the labels for the chat button and input
  CHAT_BUTTON_LABEL_TEXT: "Ask Support",
  CHAT_CANCEL_BUTTON_LABEL_TEXT: "Cancel Generation",
  CHAT_VOICE_BUTTON_LABEL_TEXT: "Voice input",
  CHAT_VOICE_REC_BUTTON_LABEL_TEXT: "Listening to voice input",
  CHAT_INPUT_PLACEHOLDER: 'Type your question, eg. "How to search and book rentals?"',
  USER_IS_BOT: "Support Assistant",
  RESET_BUTTON_LABEL_TEXT: "X",
  RESET_BUTTON_TITLE_TEXT: "Reset current question",
  RESET_CHAT_BUTTON_TITLE: "Reset chat",
  // Copy response to clipboard
  COPY_RESPONSE_BUTTON_LABEL_TEXT: "Copy Response",
  COPIED_SUCCESSFULLY_MESSAGE: "Response copied!",
  // Follow up questions text
  FOLLOW_UP_QUESTIONS_LABEL_TEXT: "You can also ask...",
  SHOW_THOUGH_PROCESS_BUTTON_LABEL_TEXT: "Show thought process",
  HIDE_THOUGH_PROCESS_BUTTON_LABEL_TEXT: "Hide thought process",
  LOADING_INDICATOR_TEXT: "Please wait. We are searching and generating an answer...",
  LOADING_TEXT: "Loading...",
  // API ERROR HANDLING IN UI
  API_ERROR_MESSAGE: "Sorry, we are having some problems. Please try again later.",
  INVALID_REQUEST_ERROR: "Unable to generate answer for this query. Please modify your question and try again.",
  // Config pertaining the response format
  THOUGHT_PROCESS_LABEL: "Thought Process",
  SUPPORT_CONTEXT_LABEL: "Support Context",
  CITATIONS_LABEL: "Learn More:",
  CITATIONS_TAB_LABEL: "Citations",
  // Custom Branding
  IS_CUSTOM_BRANDING: !1,
  // Custom Branding details
  // All these should come from persistence config
  BRANDING_URL: "#",
  BRANDING_LOGO_ALT: "Brand Logo",
  BRANDING_HEADLINE: "Welcome to the Support Assistant of our Brand",
  SHOW_CHAT_HISTORY_LABEL: "Show Chat History",
  HIDE_CHAT_HISTORY_LABEL: "Hide Chat History",
  CHAT_MAX_COUNT_TAG: "{MAX_CHAT_HISTORY}",
  CHAT_HISTORY_FOOTER_TEXT: "Showing past {MAX_CHAT_HISTORY} conversations"
}, dt = {
  TEASER_CTA_LABEL: "Ask now",
  HEADING_CHAT: "Hi, what do you want to chat about?",
  HEADING_ASK: "Hi, what do you like to answer?",
  DEFAULT_PROMPTS: [
    {
      //description: 'Může IQOS za žloutnutí zubů?',
      description: "I have a complaint, what should I do?"
    },
    {
      //description: 'K čemu jsou čistící tyčinky?',
      description: "Is Wio secure?"
    },
    {
      //description: 'Jaký je rozdíl mezi zahříváním a spalováním?',
      description: "Beneficiary received less money."
    }
  ]
}, pi = {
  approach: "rtr",
  overrides: {
    retrieval_mode: "hybrid",
    semantic_ranker: !0,
    semantic_captions: !1,
    suggest_followup_questions: !0
  }
}, sn = {
  // API URL for development purposes
  url: "http://localhost:3000",
  method: "POST",
  stream: !0
}, Li = 5, js = oe`
  :host {
    --c-primary: #123f58;
    --c-secondary: #f5f5f5;
    --c-text: var(--c-primary);
    --c-white: #fff;
    --c-black: #111111;
    --c-red: #ff0000;
    --c-light-gray: #e3e3e3;
    --c-base-gray: var(--c-secondary);
    --c-dark-gray: #4e5288;
    --c-accent-high: #692b61;
    --c-accent-dark: #5e3c7d;
    --c-accent-light: #f6d5f2;
    --c-error: #8a0000;
    --c-error-background: rgb(253, 231, 233);
    --c-success: #26b32b;
    --font-r-small: 1vw;
    --font-r-base: 3vw;
    --font-r-large: 5vw;
    --font-base: 14px;
    --font-rel-base: 1.2rem;
    --font-small: small;
    --font-large: large;
    --font-larger: x-large;
    --border-base: 3px;
    --border-thin: 1px;
    --border-thicker: 8px;
    --radius-small: 5px;
    --radius-base: 10px;
    --radius-large: 25px;
    --radius-none: 0;
    --width-wide: 90%;
    --width-base: 80%;
    --width-narrow: 50%;
    --d-base: 20px;
    --d-small: 10px;
    --d-xsmall: 5px;
    --d-large: 30px;
    --d-xlarge: 50px;
    --shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    width: 100%;
    display: block;
    padding: var(--d-base);
    color: var(--c-text);
  }
  :host([data-theme='dark']) {
    --c-primary: #fdfeff;
    --c-secondary: #32343e;
    --c-text: var(--c-primary);
    --c-white: var(--c-secondary);
    --c-black: var(--c-primary);
    --c-red: #ff0000;
    --c-light-gray: #636d9c;
    --c-dark-gray: #e3e3e3;
    --c-base-gray: var(--c-secondary);
    --c-accent-high: #dcdef8;
    --c-accent-dark: var(--c-primary);
    --c-accent-light: #032219;
    --c-error: #8a0000;
    --c-error-background: rgb(253, 231, 233);
    --c-success: #26b32b;
  }
  html {
    scroll-behavior: smooth;
  }
  ul {
    margin-block-start: 0;
    margin-block-end: 0;
  }
  .button {
    color: var(--c-text);
    border: 0;
    background: none;
    cursor: pointer;
    text-decoration: underline;
  }
  .overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    width: 100%;
    height: 0;
    background: var(--c-black);
    z-index: 2;
    opacity: 0.8;
    transition: all 0.3s ease-in-out;
  }
  .overlay.active {
    @media (max-width: 1024px) {
      height: 100%;
    }
  }
  .display-none {
    display: none;
    visibility: hidden;
  }
  .display-flex-grow {
    flex-grow: 1;
  }
  .container-col {
    display: flex;
    flex-direction: column;
    gap: var(--d-small);
  }
  .container-row {
    flex-direction: row;
  }
  .chat__header--thread {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .chat__container {
    min-width: 100%;
    transition: width 0.3s ease-in-out;
    max-height: 100vh;
  }
  .chat__containerWrapper.aside-open {
    .chat__listItem {
      max-width: var(--width-wide);
    }
  }
  .chat__containerWrapper {
    display: grid;
    grid-template-columns: 1fr;
    gutter: var(--d-base);
  }
  .chat__containerWrapper.aside-open {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: var(--d-base);
    grid-row-gap: var(--d-base);

    @media (min-width: 1024px) {
      grid-template-columns: 1fr 1fr;
    }
  }
  .chat__containerWrapper.aside-open .aside {
    width: 100%;
    border-left: var(--border-thin) solid var(--c-light-gray);

    @media (max-width: 1024px) {
      width: var(--width-base);
    }
  }
  @media (max-width: 1024px) {
    .aside {
      top: var(-d-large);
      left: auto;
      z-index: 3;
      background: var(--c-white);
      display: block;
      padding: var(--d-base);
      position: absolute;
      width: var(--width-base);
      border-radius: var(--radius-base);
    }
  }
  .form__container {
    margin-top: 50px;
  }
  .form__container-sticky {
    position: sticky;
    bottom: 0;
    z-index: 1;
    border-radius: var(--radius-base);
    background: linear-gradient(0deg, var(--c-base-gray) 0%, var(--c-base-gray) 75%, var(--c-base-gray) 100%);
    box-shadow: var(--shadow);
    padding: var(--d-large) var(--d-large) var(--d-large);
  }
  .form__label {
    display: block;
    padding: var(-d-xsmall) 0;
    font-size: var(--font-small);
  }
  .chatbox__button:disabled,
  .chatbox__input:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .chatbox__button svg {
    fill: var(--c-accent-high);
    width: calc(var(--d-base) + var(--d-xsmall));
  }
  .chatbox__container {
    position: relative;
    height: 50px;
  }
  .chatbox__button {
    background: var(--c-white);
    border: none;
    color: var(--text-color);
    font-weight: bold;
    cursor: pointer;
    border-radius: 4px;
    margin-left: 8px;
    width: calc(var(--d-large) + var(--d-xlarge));
    box-shadow: var(--shadow);
    transition: background 0.3s ease-in-out;
  }
  .chatbox__button:hover,
  .chatbox__button:focus {
    background: var(--c-secondary);
  }
  .chatbox__button:hover svg,
  .chatbox__button:focus svg {
    opacity: 0.8;
  }
  .chatbox__button--reset {
    position: absolute;
    right: 115px;
    top: 15px;
    background: transparent;
    border: none;
    color: gray;
    background: var(--c-accent-dark);
    border-radius: 50%;
    color: var(--c-white);
    font-weight: bold;
    height: 20px;
    width: var(--d-base);
    cursor: pointer;
  }
  .chatbox__input-container {
    display: flex;
    border: var(--border-thin) solid var(--c-black);
    background: var(--c-white);
    border-radius: 4px;
  }
  .chatbox__input-container:focus-within {
    outline: -webkit-focus-ring-color auto 1px;
  }
  .chatbox__input {
    background: transparent;
    color: var(--text-color);
    border: none;
    padding: var(--d-small);
    flex: 1 1 auto;
    font-size: 1rem;
  }
  .chatbox__input:focus-visible {
    outline: none;
  }
  .aside__header {
    display: flex;
    justify-content: end;
  }
  .tab-component__content {
    padding: var(--d-base) var(--d-base) var(--d-base) 0;
  }
  .tab-component__paragraph {
    font-family: monospace;
    font-size: var(--font-large);
    border: var(--border-thin) solid var(--c-light-gray);
    border-radius: var(--radius-large);
    padding: var(--d-base);
  }
  .chat-history__footer {
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: space-between;
    align-self: center;
    padding: 20px;
  }
  .chat-history__container {
    display: flex;
    flex-direction: column;
    border-bottom: 3px solid var(--light-gray);
    margin-bottom: 30px;
  }
`;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class hn extends bt {
}
hn.directiveName = "unsafeSVG", hn.resultType = 2;
const ne = Ii(hn);
function Ws(i, e) {
  const t = "Next questions:|<<([^>]+)>>", n = /\[(.*?)]/g, s = /:(.*?)(?:Follow-up questions:|Next questions:|<<|$)/s, r = /Next Questions:(.*?)$/s, o = /<<([^<>]+)>>/g, c = /^\d+\.\s/, l = {};
  let h = [], p = 1, f = i.replace(n, (N, ke) => {
    const ue = ke.trim();
    return l[ue] || (l[ue] = p++), `<sup class="citation">${l[ue]}</sup>`;
  });
  h = Object.keys(l).map((N, ke) => ({
    ref: ke + 1,
    text: N
  })), e[0] = h;
  const u = f.includes(t), _ = f.match(s), L = (_ ? _[1].trim() : "").split(`
`).filter(Boolean).map((N) => N.replace(c, ""));
  e[1] = L;
  const G = u ? r : o, ee = f.match(G) ?? [];
  let S = [];
  S = Gs([...ee]);
  const $ = f.indexOf("s:");
  return f = $ !== -1 ? i.substring(0, $ + 6) : i, e[2] = S, { replacedText: f, arrays: e };
}
function Gs(i) {
  return i && i.length > 0 && i[0].startsWith("<<") && (i = i.map((e) => e.replace("<<", "").replace(">>", ""))), i;
}
function Zs() {
  return (/* @__PURE__ */ new Date()).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: !0
  });
}
function Oi(i) {
  return i.text.map((t) => {
    var n;
    return t.value + `

` + ((n = t.followingSteps) == null ? void 0 : n.map((s, r) => `${r + 1}.` + s).join(`
`));
  }).join(`

`).replaceAll(/<sup[^>]*>(.*?)<\/sup>/g, "");
}
class pn extends Error {
  constructor(e, t) {
    super(e), this.code = t;
  }
}
function Ge(i, e, t) {
  return [...i.slice(0, e), t, ...i.slice(e + 1)];
}
const Xs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048">\r
  <path d="M960 0q97 0 187 25t168 71 143 110 110 142 71 169 25 187q0 145-55 269t-157 225q-83 82-127 183t-45 219v256q0 40-15 75t-41 61-61 41-75 15H832q-40 0-75-15t-61-41-41-61-15-75v-256q0-118-44-219t-128-183q-102-101-157-225t-55-269q0-97 25-187t71-168 110-143T604 96t169-71T960 0zm128 1920q26 0 45-19t19-45v-192H768v192q0 26 19 45t45 19h256zm67-384q12-128 65-233t144-197q83-83 127-183t45-219q0-119-45-224t-124-183-183-123-224-46q-119 0-224 45T553 297 430 480t-46 224q0 118 44 218t128 184q90 91 143 196t66 234h131v-512q0-26 19-45t45-19q26 0 45 19t19 45v512h131zM640 576q26 0 45 19l128 128q19 19 19 45t-19 45-45 19q-26 0-45-19L595 685q-19-19-19-45t19-45 45-19zm448 192q0-26 19-45l128-128q19-19 45-19t45 19 19 45q0 26-19 45l-128 128q-19 19-45 19t-45-19-19-45zM960 384q26 0 45 19t19 45v192q0 26-19 45t-45 19q-26 0-45-19t-19-45V448q0-26 19-45t45-19z" />\r
</svg>`, Ys = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048">\r
  <path d="M1792 384h-128v1472q0 40-15 75t-41 61-61 41-75 15H448q-40 0-75-15t-61-41-41-61-15-75V384H128V256h512V128q0-27 10-50t27-40 41-28 50-10h384q27 0 50 10t40 27 28 41 10 50v128h512v128zM768 256h384V128H768v128zm768 128H384v1472q0 26 19 45t45 19h1024q26 0 45-19t19-45V384zM768 1664H640V640h128v1024zm256 0H896V640h128v1024zm256 0h-128V640h128v1024z" />\r
</svg>`, Qs = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048">
  <path d="M512 768h1024v128H512V768zm1024-256H512V384h1024v128zm-384 1408l127 128H256V0h1536v1348l-64 63-64-64V128H384v1792h768zm576 125l3 3h-6l3-3zm-192-893l-129 128H512v-128h1024zm-317 384l128 128H512v-128h707zm600 192l226 227-90 90-227-226-227 227-90-91 227-227-227-227 90-90 227 227 227-227 90 91-226 226z" />
</svg>`, Ks = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048">\r
  <path d="M221 1027h931l128-64-128-64H223L18 77l1979 883L18 1843l203-816z" />\r
</svg>`, Js = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048">\r
  <path d="M2048 290l-734 734 734 734-290 290-734-734-734 734L0 1758l734-734L0 290 290 0l734 734L1758 0l290 290z" />\r
</svg>`, di = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   width="533.37976"
   height="479.4425"
   viewBox="0 0 141.12339 126.8525"
   version="1.1"
   id="svg8"
   inkscape:version="1.0.1 (c497b03c, 2020-09-10)"
   sodipodi:docname="brand-logo.svg">
  <defs
     id="defs2" />
  <sodipodi:namedview
     id="base"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageopacity="0.0"
     inkscape:pageshadow="2"
     inkscape:zoom="0.4654497"
     inkscape:cx="303.64057"
     inkscape:cy="106.60712"
     inkscape:document-units="mm"
     inkscape:current-layer="layer1"
     inkscape:document-rotation="0"
     showgrid="false"
     inkscape:window-width="1187"
     inkscape:window-height="541"
     inkscape:window-x="119"
     inkscape:window-y="131"
     inkscape:window-maximized="0"
     units="px"
     fit-margin-top="0"
     fit-margin-left="0"
     fit-margin-right="0"
     fit-margin-bottom="0" />
  <metadata
     id="metadata5">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-18.235046,-25.370501)">
    <text
       xml:space="preserve"
       style="font-style:normal;font-weight:normal;font-size:18.7575px;line-height:1.25;font-family:sans-serif;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.468938"
       x="76.622147"
       y="77.940918"
       id="text837"
       transform="scale(0.95147583,1.0509988)"><tspan
         sodipodi:role="line"
         id="tspan835"
         x="76.622147"
         y="77.940918"
         style="stroke-width:0.468938">YOUR</tspan><tspan
         sodipodi:role="line"
         x="76.622147"
         y="101.38779"
         style="stroke-width:0.468938"
         id="tspan885">BRAND</tspan></text>
    <path
       sodipodi:type="star"
       style="opacity:0.99;fill:#eec4e6;fill-opacity:0.835294;fill-rule:evenodd;stroke-width:4.99999;stroke-linejoin:round"
       id="path887"
       sodipodi:sides="5"
       sodipodi:cx="55.752526"
       sodipodi:cy="87.899637"
       sodipodi:r1="26.130005"
       sodipodi:r2="13.065002"
       sodipodi:arg1="0.77001476"
       sodipodi:arg2="1.3983333"
       inkscape:flatsided="false"
       inkscape:rounded="0"
       inkscape:randomized="0"
       d="M 74.511266,106.08993 57.994602,100.77082 44.249297,111.36137 44.204142,94.009392 29.884399,84.209489 46.373155,78.804488 51.268372,62.157267 61.504139,76.168769 78.849293,75.680123 68.686589,89.744708 Z"
       inkscape:transform-center-x="1.3856798"
       inkscape:transform-center-y="-1.1403183" />
  </g>
</svg>
`, ui = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
  <polygon points="14.65 12.05 8.05 5.35 1.35 12.05 0.65 11.35 8.05 3.95 15.35 11.35 14.65 12.05" />
</svg>`, er = oe`
  a svg {
    width: calc(var(--width-base) - var(--d-small));
    height: calc(var(--width-base) - var(--d-small));
    position: relative;
    z-index: 1;
  }
  a {
    flex-shrink: 0;
    border-radius: calc(var(--radius-large) * 3);
    border: var(--border-thicker) solid transparent;
    background-origin: border-box;
    background-clip: content-box, border-box;
    background-size: cover;
    background-image: linear-gradient(to right, var(--c-accent-light), var(--c-accent-high));
    width: calc(var(--d-xlarge) * 2);
    height: calc(var(--d-xlarge) * 2);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: var(--d-large);
    overflow: hidden;
    padding: var(--d-small);
    position: relative;
  }
  a::after {
    content: '';
    border-radius: calc(var(--radius-large) * 3);
    width: calc(var(--width-base) - var(--d-small));
    height: calc(var(--width-base) - var(--d-small));
    position: absolute;
    background-color: var(--c-secondary);
  }
`;
var tr = Object.defineProperty, nr = Object.getOwnPropertyDescriptor, At = (i, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? nr(e, t) : e, r = i.length - 1, o; r >= 0; r--)
    (o = i[r]) && (s = (n ? o(e, t, s) : o(s)) || s);
  return n && s && tr(e, t, s), s;
};
let Pe = class extends F {
  constructor() {
    super(...arguments), this.label = "", this.svgIcon = "", this.url = "";
  }
  render() {
    return w`
      <a title="${this.label}" href="${this.url}" target="_blank" rel="noopener noreferrer">
        ${ne(this.svgIcon)}
      </a>
    `;
  }
};
Pe.styles = [er];
At([
  x({ type: String })
], Pe.prototype, "label", 2);
At([
  x({ type: String })
], Pe.prototype, "svgIcon", 2);
At([
  x({ type: String })
], Pe.prototype, "url", 2);
Pe = At([
  J("link-icon")
], Pe);
const ir = oe`
  .chat-stage__header {
    display: flex;
    width: var(--width-base);
    margin: 0 auto var(--d-large);
    justify-content: center;
    align-items: center;

    @media (min-width: 1024px) {
      width: var(--width-narrow);
    }
  }
  .chat-stage__link svg {
    width: calc(var(--width-base) - var(--d-small));
    height: calc(var(--width-base) - var(--d-small));
    position: relative;
    z-index: 1;
  }
  .chat-stage__link {
    flex-shrink: 0;
    border-radius: calc(var(--radius-large) * 3);
    border: var(--border-thicker) solid transparent;
    background-origin: border-box;
    background-clip: content-box, border-box;
    background-size: cover;
    background-image: linear-gradient(to right, var(--c-accent-light), var(--c-accent-high));
    width: calc(var(--d-xlarge) * 2);
    height: calc(var(--d-xlarge) * 2);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: var(--d-large);
    overflow: hidden;
    padding: var(--d-small);
    position: relative;
  }
  .chat-stage__link::after {
    content: '';
    border-radius: calc(var(--radius-large) * 3);
    width: calc(var(--width-base) - var(--d-small));
    height: calc(var(--width-base) - var(--d-small));
    position: absolute;
    background-color: var(--c-secondary);
  }
`;
var sr = Object.defineProperty, rr = Object.getOwnPropertyDescriptor, Et = (i, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? rr(e, t) : e, r = i.length - 1, o; r >= 0; r--)
    (o = i[r]) && (s = (n ? o(e, t, s) : o(s)) || s);
  return n && s && sr(e, t, s), s;
};
let Ne = class extends F {
  constructor() {
    super(...arguments), this.pagetitle = "", this.url = "", this.svgIcon = "";
  }
  render() {
    return w`
      <header class="chat-stage__header" data-testid="chat-branding">
        <link-icon url="${this.url}" svgIcon="${this.svgIcon}"></link-icon>
        <h1 class="chat-stage__hl">${this.pagetitle}</h1>
      </header>
    `;
  }
};
Ne.styles = [ir];
Et([
  x({ type: String })
], Ne.prototype, "pagetitle", 2);
Et([
  x({ type: String })
], Ne.prototype, "url", 2);
Et([
  x({ type: String })
], Ne.prototype, "svgIcon", 2);
Ne = Et([
  J("chat-stage")
], Ne);
const or = oe`
  @keyframes spinneranimation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  p {
    display: flex;
    align-items: center;
  }
  svg {
    width: var(--d-large);
    height: 30px;
    fill: var(--c-accent-light);
    animation: spinneranimation 1s linear infinite;
    margin-right: 10px;
  }
`, ar = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\r
  <path d="M10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 10.4142 3.16421 10.75 2.75 10.75C2.33579 10.75 2 10.4142 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C9.58579 18 9.25 17.6642 9.25 17.25C9.25 16.8358 9.58579 16.5 10 16.5C13.5899 16.5 16.5 13.5899 16.5 10C16.5 6.41015 13.5899 3.5 10 3.5Z" />\r
</svg>`;
var lr = Object.defineProperty, cr = Object.getOwnPropertyDescriptor, Di = (i, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? cr(e, t) : e, r = i.length - 1, o; r >= 0; r--)
    (o = i[r]) && (s = (n ? o(e, t, s) : o(s)) || s);
  return n && s && lr(e, t, s), s;
};
let wt = class extends F {
  constructor() {
    super(...arguments), this.label = "";
  }
  render() {
    return w`
      <p data-testid="loading-indicator" aria-label="${this.label}">
        <span>${ne(ar)}</span>
        <span>${this.label}</span>
      </p>
    `;
  }
};
wt.styles = [or];
Di([
  x({ type: String })
], wt.prototype, "label", 2);
wt = Di([
  J("loading-indicator")
], wt);
const hr = oe`
  button {
    color: var(--text-color);
    font-weight: bold;
    margin-left: 8px;
    background: transparent;
    transition: background 0.3s ease-in-out;
    box-shadow: none;
    border: none;
    cursor: pointer;
    width: var(--d-xlarge);
    height: 100%;
  }
  button:hover,
  button:focus {
    background: var(--c-secondary);
  }
  button:hover svg,
  button:focus svg {
    opacity: 0.8;
  }
  .not-recording svg {
    fill: var(--c-black);
  }
  .recording svg {
    fill: var(--red);
  }
`, pr = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M18.25 11C18.6297 11 18.9435 11.2822 18.9932 11.6482L19 11.75V12.25C19 15.8094 16.245 18.7254 12.751 18.9817L12.75 21.25C12.75 21.6642 12.4142 22 12 22C11.6203 22 11.3065 21.7178 11.2568 21.3518L11.25 21.25L11.25 18.9818C7.83323 18.7316 5.12283 15.938 5.00406 12.4863L5 12.25V11.75C5 11.3358 5.33579 11 5.75 11C6.1297 11 6.44349 11.2822 6.49315 11.6482L6.5 11.75V12.25C6.5 15.077 8.73445 17.3821 11.5336 17.4956L11.75 17.5H12.25C15.077 17.5 17.3821 15.2656 17.4956 12.4664L17.5 12.25V11.75C17.5 11.3358 17.8358 11 18.25 11ZM12 2C14.2091 2 16 3.79086 16 6V12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12V6C8 3.79086 9.79086 2 12 2Z"  />
</svg>`, dr = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M11 17.5C11 18.596 11.2713 19.6287 11.7503 20.5345L11.75 21.25C11.75 21.6642 11.4142 22 11 22C10.6203 22 10.3065 21.7178 10.2568 21.3518L10.25 21.25L10.25 18.9818C6.83323 18.7316 4.12283 15.938 4.00406 12.4863L4 12.25V11.75C4 11.3358 4.33579 11 4.75 11C5.1297 11 5.44349 11.2822 5.49315 11.6482L5.5 11.75V12.25C5.5 15.077 7.73445 17.3821 10.5336 17.4956L10.75 17.5H11ZM11.1748 15.9962C11.6577 13.9575 13.1007 12.2902 15 11.4982V6C15 3.79086 13.2091 2 11 2C8.79086 2 7 3.79086 7 6V12C7 14.2091 8.79086 16 11 16C11.0586 16 11.1169 15.9987 11.1748 15.9962ZM20 17.5C20 18.8807 18.8807 20 17.5 20C16.1193 20 15 18.8807 15 17.5C15 16.1193 16.1193 15 17.5 15C18.8807 15 20 16.1193 20 17.5ZM23 17.5C23 20.5376 20.5376 23 17.5 23C14.4624 23 12 20.5376 12 17.5C12 14.4624 14.4624 12 17.5 12C20.5376 12 23 14.4624 23 17.5ZM13.5 17.5C13.5 19.7091 15.2909 21.5 17.5 21.5C19.7091 21.5 21.5 19.7091 21.5 17.5C21.5 15.2909 19.7091 13.5 17.5 13.5C15.2909 13.5 13.5 15.2909 13.5 17.5Z" />
</svg>`;
var ur = Object.defineProperty, fr = Object.getOwnPropertyDescriptor, _n = (i, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? fr(e, t) : e, r = i.length - 1, o; r >= 0; r--)
    (o = i[r]) && (s = (n ? o(e, t, s) : o(s)) || s);
  return n && s && ur(e, t, s), s;
};
let Je = class extends F {
  constructor() {
    super(...arguments), this.recognitionSvc = window.SpeechRecognition || window.webkitSpeechRecognition, this.showVoiceInput = this.recognitionSvc !== void 0, this.enableVoiceListening = !1, this.speechRecognition = void 0;
  }
  initializeSpeechRecognition() {
    if (this.showVoiceInput && this.recognitionSvc) {
      if (this.speechRecognition = new this.recognitionSvc(), !this.speechRecognition)
        return;
      this.speechRecognition.continuous = !0, this.speechRecognition.lang = "en-US", this.speechRecognition.onresult = (i) => {
        let e = "";
        for (const n of i.results)
          e += `${n[0].transcript}`;
        const t = new CustomEvent("on-voice-input", {
          detail: {
            input: e
          },
          bubbles: !0,
          composed: !0
        });
        this.dispatchEvent(t);
      }, this.speechRecognition.addEventListener("error", (i) => {
        this.speechRecognition && (this.speechRecognition.stop(), console.log(`Speech recognition error detected: ${i.error} - ${i.message}`));
      });
    }
  }
  handleVoiceInput(i) {
    i.preventDefault(), this.speechRecognition || this.initializeSpeechRecognition(), this.speechRecognition && (this.enableVoiceListening = !this.enableVoiceListening, this.enableVoiceListening ? this.speechRecognition.start() : this.speechRecognition.stop());
  }
  renderVoiceButton() {
    return w`
      <button
        title="${this.enableVoiceListening ? T.CHAT_VOICE_REC_BUTTON_LABEL_TEXT : T.CHAT_VOICE_BUTTON_LABEL_TEXT}"
        class="${this.enableVoiceListening ? "recording" : "not-recording"}"
        @click="${this.handleVoiceInput}"
      >
        ${this.enableVoiceListening ? ne(dr) : ne(pr)}
      </button>
    `;
  }
  render() {
    return this.showVoiceInput ? this.renderVoiceButton() : w``;
  }
};
Je.styles = [hr];
_n([
  Q()
], Je.prototype, "showVoiceInput", 2);
_n([
  Q()
], Je.prototype, "enableVoiceListening", 2);
Je = _n([
  J("voice-input-button")
], Je);
function bn() {
  return {
    async: !1,
    breaks: !1,
    extensions: null,
    gfm: !0,
    hooks: null,
    pedantic: !1,
    renderer: null,
    silent: !1,
    tokenizer: null,
    walkTokens: null
  };
}
let Te = bn();
function Pi(i) {
  Te = i;
}
const Ni = /[&<>"']/, gr = new RegExp(Ni.source, "g"), Mi = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, mr = new RegExp(Mi.source, "g"), _r = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, fi = (i) => _r[i];
function X(i, e) {
  if (e) {
    if (Ni.test(i))
      return i.replace(gr, fi);
  } else if (Mi.test(i))
    return i.replace(mr, fi);
  return i;
}
const br = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function vr(i) {
  return i.replace(br, (e, t) => (t = t.toLowerCase(), t === "colon" ? ":" : t.charAt(0) === "#" ? t.charAt(1) === "x" ? String.fromCharCode(parseInt(t.substring(2), 16)) : String.fromCharCode(+t.substring(1)) : ""));
}
const wr = /(^|[^\[])\^/g;
function k(i, e) {
  i = typeof i == "string" ? i : i.source, e = e || "";
  const t = {
    replace: (n, s) => (s = typeof s == "object" && "source" in s ? s.source : s, s = s.replace(wr, "$1"), i = i.replace(n, s), t),
    getRegex: () => new RegExp(i, e)
  };
  return t;
}
function gi(i) {
  try {
    i = encodeURI(i).replace(/%25/g, "%");
  } catch {
    return null;
  }
  return i;
}
const yt = { exec: () => null };
function mi(i, e) {
  const t = i.replace(/\|/g, (r, o, c) => {
    let l = !1, h = o;
    for (; --h >= 0 && c[h] === "\\"; )
      l = !l;
    return l ? "|" : " |";
  }), n = t.split(/ \|/);
  let s = 0;
  if (n[0].trim() || n.shift(), n.length > 0 && !n[n.length - 1].trim() && n.pop(), e)
    if (n.length > e)
      n.splice(e);
    else
      for (; n.length < e; )
        n.push("");
  for (; s < n.length; s++)
    n[s] = n[s].trim().replace(/\\\|/g, "|");
  return n;
}
function ut(i, e, t) {
  const n = i.length;
  if (n === 0)
    return "";
  let s = 0;
  for (; s < n; ) {
    const r = i.charAt(n - s - 1);
    if (r === e && !t)
      s++;
    else if (r !== e && t)
      s++;
    else
      break;
  }
  return i.slice(0, n - s);
}
function yr(i, e) {
  if (i.indexOf(e[1]) === -1)
    return -1;
  let t = 0;
  for (let n = 0; n < i.length; n++)
    if (i[n] === "\\")
      n++;
    else if (i[n] === e[0])
      t++;
    else if (i[n] === e[1] && (t--, t < 0))
      return n;
  return -1;
}
function _i(i, e, t, n) {
  const s = e.href, r = e.title ? X(e.title) : null, o = i[1].replace(/\\([\[\]])/g, "$1");
  if (i[0].charAt(0) !== "!") {
    n.state.inLink = !0;
    const c = {
      type: "link",
      raw: t,
      href: s,
      title: r,
      text: o,
      tokens: n.inlineTokens(o)
    };
    return n.state.inLink = !1, c;
  }
  return {
    type: "image",
    raw: t,
    href: s,
    title: r,
    text: X(o)
  };
}
function xr(i, e) {
  const t = i.match(/^(\s+)(?:```)/);
  if (t === null)
    return e;
  const n = t[1];
  return e.split(`
`).map((s) => {
    const r = s.match(/^\s+/);
    if (r === null)
      return s;
    const [o] = r;
    return o.length >= n.length ? s.slice(n.length) : s;
  }).join(`
`);
}
class xt {
  constructor(e) {
    R(this, "options");
    // TODO: Fix this rules type
    R(this, "rules");
    R(this, "lexer");
    this.options = e || Te;
  }
  space(e) {
    const t = this.rules.block.newline.exec(e);
    if (t && t[0].length > 0)
      return {
        type: "space",
        raw: t[0]
      };
  }
  code(e) {
    const t = this.rules.block.code.exec(e);
    if (t) {
      const n = t[0].replace(/^ {1,4}/gm, "");
      return {
        type: "code",
        raw: t[0],
        codeBlockStyle: "indented",
        text: this.options.pedantic ? n : ut(n, `
`)
      };
    }
  }
  fences(e) {
    const t = this.rules.block.fences.exec(e);
    if (t) {
      const n = t[0], s = xr(n, t[3] || "");
      return {
        type: "code",
        raw: n,
        lang: t[2] ? t[2].trim().replace(this.rules.inline._escapes, "$1") : t[2],
        text: s
      };
    }
  }
  heading(e) {
    const t = this.rules.block.heading.exec(e);
    if (t) {
      let n = t[2].trim();
      if (/#$/.test(n)) {
        const s = ut(n, "#");
        (this.options.pedantic || !s || / $/.test(s)) && (n = s.trim());
      }
      return {
        type: "heading",
        raw: t[0],
        depth: t[1].length,
        text: n,
        tokens: this.lexer.inline(n)
      };
    }
  }
  hr(e) {
    const t = this.rules.block.hr.exec(e);
    if (t)
      return {
        type: "hr",
        raw: t[0]
      };
  }
  blockquote(e) {
    const t = this.rules.block.blockquote.exec(e);
    if (t) {
      const n = ut(t[0].replace(/^ *>[ \t]?/gm, ""), `
`), s = this.lexer.state.top;
      this.lexer.state.top = !0;
      const r = this.lexer.blockTokens(n);
      return this.lexer.state.top = s, {
        type: "blockquote",
        raw: t[0],
        tokens: r,
        text: n
      };
    }
  }
  list(e) {
    let t = this.rules.block.list.exec(e);
    if (t) {
      let n = t[1].trim();
      const s = n.length > 1, r = {
        type: "list",
        raw: "",
        ordered: s,
        start: s ? +n.slice(0, -1) : "",
        loose: !1,
        items: []
      };
      n = s ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = s ? n : "[*+-]");
      const o = new RegExp(`^( {0,3}${n})((?:[	 ][^\\n]*)?(?:\\n|$))`);
      let c = "", l = "", h = !1;
      for (; e; ) {
        let p = !1;
        if (!(t = o.exec(e)) || this.rules.block.hr.test(e))
          break;
        c = t[0], e = e.substring(c.length);
        let f = t[2].split(`
`, 1)[0].replace(/^\t+/, (G) => " ".repeat(3 * G.length)), u = e.split(`
`, 1)[0], _ = 0;
        this.options.pedantic ? (_ = 2, l = f.trimStart()) : (_ = t[2].search(/[^ ]/), _ = _ > 4 ? 1 : _, l = f.slice(_), _ += t[1].length);
        let C = !1;
        if (!f && /^ *$/.test(u) && (c += u + `
`, e = e.substring(u.length + 1), p = !0), !p) {
          const G = new RegExp(`^ {0,${Math.min(3, _ - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`), ee = new RegExp(`^ {0,${Math.min(3, _ - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), S = new RegExp(`^ {0,${Math.min(3, _ - 1)}}(?:\`\`\`|~~~)`), $ = new RegExp(`^ {0,${Math.min(3, _ - 1)}}#`);
          for (; e; ) {
            const N = e.split(`
`, 1)[0];
            if (u = N, this.options.pedantic && (u = u.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), S.test(u) || $.test(u) || G.test(u) || ee.test(e))
              break;
            if (u.search(/[^ ]/) >= _ || !u.trim())
              l += `
` + u.slice(_);
            else {
              if (C || f.search(/[^ ]/) >= 4 || S.test(f) || $.test(f) || ee.test(f))
                break;
              l += `
` + u;
            }
            !C && !u.trim() && (C = !0), c += N + `
`, e = e.substring(N.length + 1), f = u.slice(_);
          }
        }
        r.loose || (h ? r.loose = !0 : /\n *\n *$/.test(c) && (h = !0));
        let E = null, L;
        this.options.gfm && (E = /^\[[ xX]\] /.exec(l), E && (L = E[0] !== "[ ] ", l = l.replace(/^\[[ xX]\] +/, ""))), r.items.push({
          type: "list_item",
          raw: c,
          task: !!E,
          checked: L,
          loose: !1,
          text: l,
          tokens: []
        }), r.raw += c;
      }
      r.items[r.items.length - 1].raw = c.trimEnd(), r.items[r.items.length - 1].text = l.trimEnd(), r.raw = r.raw.trimEnd();
      for (let p = 0; p < r.items.length; p++)
        if (this.lexer.state.top = !1, r.items[p].tokens = this.lexer.blockTokens(r.items[p].text, []), !r.loose) {
          const f = r.items[p].tokens.filter((_) => _.type === "space"), u = f.length > 0 && f.some((_) => /\n.*\n/.test(_.raw));
          r.loose = u;
        }
      if (r.loose)
        for (let p = 0; p < r.items.length; p++)
          r.items[p].loose = !0;
      return r;
    }
  }
  html(e) {
    const t = this.rules.block.html.exec(e);
    if (t)
      return {
        type: "html",
        block: !0,
        raw: t[0],
        pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
        text: t[0]
      };
  }
  def(e) {
    const t = this.rules.block.def.exec(e);
    if (t) {
      const n = t[1].toLowerCase().replace(/\s+/g, " "), s = t[2] ? t[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline._escapes, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline._escapes, "$1") : t[3];
      return {
        type: "def",
        tag: n,
        raw: t[0],
        href: s,
        title: r
      };
    }
  }
  table(e) {
    const t = this.rules.block.table.exec(e);
    if (t) {
      if (!/[:|]/.test(t[2]))
        return;
      const n = {
        type: "table",
        raw: t[0],
        header: mi(t[1]).map((s) => ({ text: s, tokens: [] })),
        align: t[2].replace(/^\||\| *$/g, "").split("|"),
        rows: t[3] && t[3].trim() ? t[3].replace(/\n[ \t]*$/, "").split(`
`) : []
      };
      if (n.header.length === n.align.length) {
        let s = n.align.length, r, o, c, l;
        for (r = 0; r < s; r++) {
          const h = n.align[r];
          h && (/^ *-+: *$/.test(h) ? n.align[r] = "right" : /^ *:-+: *$/.test(h) ? n.align[r] = "center" : /^ *:-+ *$/.test(h) ? n.align[r] = "left" : n.align[r] = null);
        }
        for (s = n.rows.length, r = 0; r < s; r++)
          n.rows[r] = mi(n.rows[r], n.header.length).map((h) => ({ text: h, tokens: [] }));
        for (s = n.header.length, o = 0; o < s; o++)
          n.header[o].tokens = this.lexer.inline(n.header[o].text);
        for (s = n.rows.length, o = 0; o < s; o++)
          for (l = n.rows[o], c = 0; c < l.length; c++)
            l[c].tokens = this.lexer.inline(l[c].text);
        return n;
      }
    }
  }
  lheading(e) {
    const t = this.rules.block.lheading.exec(e);
    if (t)
      return {
        type: "heading",
        raw: t[0],
        depth: t[2].charAt(0) === "=" ? 1 : 2,
        text: t[1],
        tokens: this.lexer.inline(t[1])
      };
  }
  paragraph(e) {
    const t = this.rules.block.paragraph.exec(e);
    if (t) {
      const n = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
      return {
        type: "paragraph",
        raw: t[0],
        text: n,
        tokens: this.lexer.inline(n)
      };
    }
  }
  text(e) {
    const t = this.rules.block.text.exec(e);
    if (t)
      return {
        type: "text",
        raw: t[0],
        text: t[0],
        tokens: this.lexer.inline(t[0])
      };
  }
  escape(e) {
    const t = this.rules.inline.escape.exec(e);
    if (t)
      return {
        type: "escape",
        raw: t[0],
        text: X(t[1])
      };
  }
  tag(e) {
    const t = this.rules.inline.tag.exec(e);
    if (t)
      return !this.lexer.state.inLink && /^<a /i.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
        type: "html",
        raw: t[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        block: !1,
        text: t[0]
      };
  }
  link(e) {
    const t = this.rules.inline.link.exec(e);
    if (t) {
      const n = t[2].trim();
      if (!this.options.pedantic && /^</.test(n)) {
        if (!/>$/.test(n))
          return;
        const o = ut(n.slice(0, -1), "\\");
        if ((n.length - o.length) % 2 === 0)
          return;
      } else {
        const o = yr(t[2], "()");
        if (o > -1) {
          const l = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + o;
          t[2] = t[2].substring(0, o), t[0] = t[0].substring(0, l).trim(), t[3] = "";
        }
      }
      let s = t[2], r = "";
      if (this.options.pedantic) {
        const o = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(s);
        o && (s = o[1], r = o[3]);
      } else
        r = t[3] ? t[3].slice(1, -1) : "";
      return s = s.trim(), /^</.test(s) && (this.options.pedantic && !/>$/.test(n) ? s = s.slice(1) : s = s.slice(1, -1)), _i(t, {
        href: s && s.replace(this.rules.inline._escapes, "$1"),
        title: r && r.replace(this.rules.inline._escapes, "$1")
      }, t[0], this.lexer);
    }
  }
  reflink(e, t) {
    let n;
    if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
      let s = (n[2] || n[1]).replace(/\s+/g, " ");
      if (s = t[s.toLowerCase()], !s) {
        const r = n[0].charAt(0);
        return {
          type: "text",
          raw: r,
          text: r
        };
      }
      return _i(n, s, n[0], this.lexer);
    }
  }
  emStrong(e, t, n = "") {
    let s = this.rules.inline.emStrong.lDelim.exec(e);
    if (!s || s[3] && n.match(/[\p{L}\p{N}]/u))
      return;
    if (!(s[1] || s[2] || "") || !n || this.rules.inline.punctuation.exec(n)) {
      const o = [...s[0]].length - 1;
      let c, l, h = o, p = 0;
      const f = s[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
      for (f.lastIndex = 0, t = t.slice(-1 * e.length + o); (s = f.exec(t)) != null; ) {
        if (c = s[1] || s[2] || s[3] || s[4] || s[5] || s[6], !c)
          continue;
        if (l = [...c].length, s[3] || s[4]) {
          h += l;
          continue;
        } else if ((s[5] || s[6]) && o % 3 && !((o + l) % 3)) {
          p += l;
          continue;
        }
        if (h -= l, h > 0)
          continue;
        l = Math.min(l, l + h + p);
        const u = [...s[0]][0].length, _ = e.slice(0, o + s.index + u + l);
        if (Math.min(o, l) % 2) {
          const E = _.slice(1, -1);
          return {
            type: "em",
            raw: _,
            text: E,
            tokens: this.lexer.inlineTokens(E)
          };
        }
        const C = _.slice(2, -2);
        return {
          type: "strong",
          raw: _,
          text: C,
          tokens: this.lexer.inlineTokens(C)
        };
      }
    }
  }
  codespan(e) {
    const t = this.rules.inline.code.exec(e);
    if (t) {
      let n = t[2].replace(/\n/g, " ");
      const s = /[^ ]/.test(n), r = /^ /.test(n) && / $/.test(n);
      return s && r && (n = n.substring(1, n.length - 1)), n = X(n, !0), {
        type: "codespan",
        raw: t[0],
        text: n
      };
    }
  }
  br(e) {
    const t = this.rules.inline.br.exec(e);
    if (t)
      return {
        type: "br",
        raw: t[0]
      };
  }
  del(e) {
    const t = this.rules.inline.del.exec(e);
    if (t)
      return {
        type: "del",
        raw: t[0],
        text: t[2],
        tokens: this.lexer.inlineTokens(t[2])
      };
  }
  autolink(e) {
    const t = this.rules.inline.autolink.exec(e);
    if (t) {
      let n, s;
      return t[2] === "@" ? (n = X(t[1]), s = "mailto:" + n) : (n = X(t[1]), s = n), {
        type: "link",
        raw: t[0],
        text: n,
        href: s,
        tokens: [
          {
            type: "text",
            raw: n,
            text: n
          }
        ]
      };
    }
  }
  url(e) {
    let t;
    if (t = this.rules.inline.url.exec(e)) {
      let n, s;
      if (t[2] === "@")
        n = X(t[0]), s = "mailto:" + n;
      else {
        let r;
        do
          r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])[0];
        while (r !== t[0]);
        n = X(t[0]), t[1] === "www." ? s = "http://" + t[0] : s = t[0];
      }
      return {
        type: "link",
        raw: t[0],
        text: n,
        href: s,
        tokens: [
          {
            type: "text",
            raw: n,
            text: n
          }
        ]
      };
    }
  }
  inlineText(e) {
    const t = this.rules.inline.text.exec(e);
    if (t) {
      let n;
      return this.lexer.state.inRawBlock ? n = t[0] : n = X(t[0]), {
        type: "text",
        raw: t[0],
        text: n
      };
    }
  }
}
const v = {
  newline: /^(?: *(?:\n|$))+/,
  code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
  fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
  hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
  html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
  def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
  table: yt,
  lheading: /^(?!bull )((?:.|\n(?!\s*?\n|bull ))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  // regex template, placeholders will be replaced according to different paragraph
  // interruption rules of commonmark and the original markdown spec:
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
  text: /^[^\n]+/
};
v._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
v._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
v.def = k(v.def).replace("label", v._label).replace("title", v._title).getRegex();
v.bullet = /(?:[*+-]|\d{1,9}[.)])/;
v.listItemStart = k(/^( *)(bull) */).replace("bull", v.bullet).getRegex();
v.list = k(v.list).replace(/bull/g, v.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + v.def.source + ")").getRegex();
v._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
v._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
v.html = k(v.html, "i").replace("comment", v._comment).replace("tag", v._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
v.lheading = k(v.lheading).replace(/bull/g, v.bullet).getRegex();
v.paragraph = k(v._paragraph).replace("hr", v.hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v._tag).getRegex();
v.blockquote = k(v.blockquote).replace("paragraph", v.paragraph).getRegex();
v.normal = { ...v };
v.gfm = {
  ...v.normal,
  table: "^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
  // Cells
};
v.gfm.table = k(v.gfm.table).replace("hr", v.hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v._tag).getRegex();
v.gfm.paragraph = k(v._paragraph).replace("hr", v.hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", v.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v._tag).getRegex();
v.pedantic = {
  ...v.normal,
  html: k(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", v._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: yt,
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: k(v.normal._paragraph).replace("hr", v.hr).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", v.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
};
const g = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: yt,
  tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(ref)\]/,
  nolink: /^!?\[(ref)\](?:\[\])?/,
  reflinkSearch: "reflink|nolink(?!\\()",
  emStrong: {
    lDelim: /^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/,
    //         (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
    //         | Skip orphan inside strong      | Consume to delim | (1) #***              | (2) a***#, a***                    | (3) #***a, ***a                  | (4) ***#                 | (5) #***#                         | (6) a***a
    rDelimAst: /^[^_*]*?__[^_*]*?\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\*)[punct](\*+)(?=[\s]|$)|[^punct\s](\*+)(?!\*)(?=[punct\s]|$)|(?!\*)[punct\s](\*+)(?=[^punct\s])|[\s](\*+)(?!\*)(?=[punct])|(?!\*)[punct](\*+)(?!\*)(?=[punct])|[^punct\s](\*+)(?=[^punct\s])/,
    rDelimUnd: /^[^_*]*?\*\*[^_*]*?_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\s]|$)|[^punct\s](_+)(?!_)(?=[punct\s]|$)|(?!_)[punct\s](_+)(?=[^punct\s])|[\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])/
    // ^- Not allowed for _
  },
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: yt,
  text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
  punctuation: /^((?![*_])[\spunctuation])/
};
g._punctuation = "\\p{P}$+<=>`^|~";
g.punctuation = k(g.punctuation, "u").replace(/punctuation/g, g._punctuation).getRegex();
g.blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
g.anyPunctuation = /\\[punct]/g;
g._escapes = /\\([punct])/g;
g._comment = k(v._comment).replace("(?:-->|$)", "-->").getRegex();
g.emStrong.lDelim = k(g.emStrong.lDelim, "u").replace(/punct/g, g._punctuation).getRegex();
g.emStrong.rDelimAst = k(g.emStrong.rDelimAst, "gu").replace(/punct/g, g._punctuation).getRegex();
g.emStrong.rDelimUnd = k(g.emStrong.rDelimUnd, "gu").replace(/punct/g, g._punctuation).getRegex();
g.anyPunctuation = k(g.anyPunctuation, "gu").replace(/punct/g, g._punctuation).getRegex();
g._escapes = k(g._escapes, "gu").replace(/punct/g, g._punctuation).getRegex();
g._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
g._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
g.autolink = k(g.autolink).replace("scheme", g._scheme).replace("email", g._email).getRegex();
g._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
g.tag = k(g.tag).replace("comment", g._comment).replace("attribute", g._attribute).getRegex();
g._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
g._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
g._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
g.link = k(g.link).replace("label", g._label).replace("href", g._href).replace("title", g._title).getRegex();
g.reflink = k(g.reflink).replace("label", g._label).replace("ref", v._label).getRegex();
g.nolink = k(g.nolink).replace("ref", v._label).getRegex();
g.reflinkSearch = k(g.reflinkSearch, "g").replace("reflink", g.reflink).replace("nolink", g.nolink).getRegex();
g.normal = { ...g };
g.pedantic = {
  ...g.normal,
  strong: {
    start: /^__|\*\*/,
    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    endAst: /\*\*(?!\*)/g,
    endUnd: /__(?!_)/g
  },
  em: {
    start: /^_|\*/,
    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
    endAst: /\*(?!\*)/g,
    endUnd: /_(?!_)/g
  },
  link: k(/^!?\[(label)\]\((.*?)\)/).replace("label", g._label).getRegex(),
  reflink: k(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", g._label).getRegex()
};
g.gfm = {
  ...g.normal,
  escape: k(g.escape).replace("])", "~|])").getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
g.gfm.url = k(g.gfm.url, "i").replace("email", g.gfm._extended_email).getRegex();
g.breaks = {
  ...g.gfm,
  br: k(g.br).replace("{2,}", "*").getRegex(),
  text: k(g.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
};
class ie {
  constructor(e) {
    R(this, "tokens");
    R(this, "options");
    R(this, "state");
    R(this, "tokenizer");
    R(this, "inlineQueue");
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = e || Te, this.options.tokenizer = this.options.tokenizer || new xt(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
      inLink: !1,
      inRawBlock: !1,
      top: !0
    };
    const t = {
      block: v.normal,
      inline: g.normal
    };
    this.options.pedantic ? (t.block = v.pedantic, t.inline = g.pedantic) : this.options.gfm && (t.block = v.gfm, this.options.breaks ? t.inline = g.breaks : t.inline = g.gfm), this.tokenizer.rules = t;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block: v,
      inline: g
    };
  }
  /**
   * Static Lex Method
   */
  static lex(e, t) {
    return new ie(t).lex(e);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(e, t) {
    return new ie(t).inlineTokens(e);
  }
  /**
   * Preprocessing
   */
  lex(e) {
    e = e.replace(/\r\n|\r/g, `
`), this.blockTokens(e, this.tokens);
    let t;
    for (; t = this.inlineQueue.shift(); )
      this.inlineTokens(t.src, t.tokens);
    return this.tokens;
  }
  blockTokens(e, t = []) {
    this.options.pedantic ? e = e.replace(/\t/g, "    ").replace(/^ +$/gm, "") : e = e.replace(/^( *)(\t+)/gm, (c, l, h) => l + "    ".repeat(h.length));
    let n, s, r, o;
    for (; e; )
      if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((c) => (n = c.call({ lexer: this }, e, t)) ? (e = e.substring(n.raw.length), t.push(n), !0) : !1))) {
        if (n = this.tokenizer.space(e)) {
          e = e.substring(n.raw.length), n.raw.length === 1 && t.length > 0 ? t[t.length - 1].raw += `
` : t.push(n);
          continue;
        }
        if (n = this.tokenizer.code(e)) {
          e = e.substring(n.raw.length), s = t[t.length - 1], s && (s.type === "paragraph" || s.type === "text") ? (s.raw += `
` + n.raw, s.text += `
` + n.text, this.inlineQueue[this.inlineQueue.length - 1].src = s.text) : t.push(n);
          continue;
        }
        if (n = this.tokenizer.fences(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.heading(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.hr(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.blockquote(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.list(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.html(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.def(e)) {
          e = e.substring(n.raw.length), s = t[t.length - 1], s && (s.type === "paragraph" || s.type === "text") ? (s.raw += `
` + n.raw, s.text += `
` + n.raw, this.inlineQueue[this.inlineQueue.length - 1].src = s.text) : this.tokens.links[n.tag] || (this.tokens.links[n.tag] = {
            href: n.href,
            title: n.title
          });
          continue;
        }
        if (n = this.tokenizer.table(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.lheading(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (r = e, this.options.extensions && this.options.extensions.startBlock) {
          let c = 1 / 0;
          const l = e.slice(1);
          let h;
          this.options.extensions.startBlock.forEach((p) => {
            h = p.call({ lexer: this }, l), typeof h == "number" && h >= 0 && (c = Math.min(c, h));
          }), c < 1 / 0 && c >= 0 && (r = e.substring(0, c + 1));
        }
        if (this.state.top && (n = this.tokenizer.paragraph(r))) {
          s = t[t.length - 1], o && s.type === "paragraph" ? (s.raw += `
` + n.raw, s.text += `
` + n.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = s.text) : t.push(n), o = r.length !== e.length, e = e.substring(n.raw.length);
          continue;
        }
        if (n = this.tokenizer.text(e)) {
          e = e.substring(n.raw.length), s = t[t.length - 1], s && s.type === "text" ? (s.raw += `
` + n.raw, s.text += `
` + n.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = s.text) : t.push(n);
          continue;
        }
        if (e) {
          const c = "Infinite loop on byte: " + e.charCodeAt(0);
          if (this.options.silent) {
            console.error(c);
            break;
          } else
            throw new Error(c);
        }
      }
    return this.state.top = !0, t;
  }
  inline(e, t = []) {
    return this.inlineQueue.push({ src: e, tokens: t }), t;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(e, t = []) {
    let n, s, r, o = e, c, l, h;
    if (this.tokens.links) {
      const p = Object.keys(this.tokens.links);
      if (p.length > 0)
        for (; (c = this.tokenizer.rules.inline.reflinkSearch.exec(o)) != null; )
          p.includes(c[0].slice(c[0].lastIndexOf("[") + 1, -1)) && (o = o.slice(0, c.index) + "[" + "a".repeat(c[0].length - 2) + "]" + o.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (c = this.tokenizer.rules.inline.blockSkip.exec(o)) != null; )
      o = o.slice(0, c.index) + "[" + "a".repeat(c[0].length - 2) + "]" + o.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    for (; (c = this.tokenizer.rules.inline.anyPunctuation.exec(o)) != null; )
      o = o.slice(0, c.index) + "++" + o.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
    for (; e; )
      if (l || (h = ""), l = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((p) => (n = p.call({ lexer: this }, e, t)) ? (e = e.substring(n.raw.length), t.push(n), !0) : !1))) {
        if (n = this.tokenizer.escape(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.tag(e)) {
          e = e.substring(n.raw.length), s = t[t.length - 1], s && n.type === "text" && s.type === "text" ? (s.raw += n.raw, s.text += n.text) : t.push(n);
          continue;
        }
        if (n = this.tokenizer.link(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.reflink(e, this.tokens.links)) {
          e = e.substring(n.raw.length), s = t[t.length - 1], s && n.type === "text" && s.type === "text" ? (s.raw += n.raw, s.text += n.text) : t.push(n);
          continue;
        }
        if (n = this.tokenizer.emStrong(e, o, h)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.codespan(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.br(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.del(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (n = this.tokenizer.autolink(e)) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (!this.state.inLink && (n = this.tokenizer.url(e))) {
          e = e.substring(n.raw.length), t.push(n);
          continue;
        }
        if (r = e, this.options.extensions && this.options.extensions.startInline) {
          let p = 1 / 0;
          const f = e.slice(1);
          let u;
          this.options.extensions.startInline.forEach((_) => {
            u = _.call({ lexer: this }, f), typeof u == "number" && u >= 0 && (p = Math.min(p, u));
          }), p < 1 / 0 && p >= 0 && (r = e.substring(0, p + 1));
        }
        if (n = this.tokenizer.inlineText(r)) {
          e = e.substring(n.raw.length), n.raw.slice(-1) !== "_" && (h = n.raw.slice(-1)), l = !0, s = t[t.length - 1], s && s.type === "text" ? (s.raw += n.raw, s.text += n.text) : t.push(n);
          continue;
        }
        if (e) {
          const p = "Infinite loop on byte: " + e.charCodeAt(0);
          if (this.options.silent) {
            console.error(p);
            break;
          } else
            throw new Error(p);
        }
      }
    return t;
  }
}
class Tt {
  constructor(e) {
    R(this, "options");
    this.options = e || Te;
  }
  code(e, t, n) {
    var r;
    const s = (r = (t || "").match(/^\S*/)) == null ? void 0 : r[0];
    return e = e.replace(/\n$/, "") + `
`, s ? '<pre><code class="language-' + X(s) + '">' + (n ? e : X(e, !0)) + `</code></pre>
` : "<pre><code>" + (n ? e : X(e, !0)) + `</code></pre>
`;
  }
  blockquote(e) {
    return `<blockquote>
${e}</blockquote>
`;
  }
  html(e, t) {
    return e;
  }
  heading(e, t, n) {
    return `<h${t}>${e}</h${t}>
`;
  }
  hr() {
    return `<hr>
`;
  }
  list(e, t, n) {
    const s = t ? "ol" : "ul", r = t && n !== 1 ? ' start="' + n + '"' : "";
    return "<" + s + r + `>
` + e + "</" + s + `>
`;
  }
  listitem(e, t, n) {
    return `<li>${e}</li>
`;
  }
  checkbox(e) {
    return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
  }
  paragraph(e) {
    return `<p>${e}</p>
`;
  }
  table(e, t) {
    return t && (t = `<tbody>${t}</tbody>`), `<table>
<thead>
` + e + `</thead>
` + t + `</table>
`;
  }
  tablerow(e) {
    return `<tr>
${e}</tr>
`;
  }
  tablecell(e, t) {
    const n = t.header ? "th" : "td";
    return (t.align ? `<${n} align="${t.align}">` : `<${n}>`) + e + `</${n}>
`;
  }
  /**
   * span level renderer
   */
  strong(e) {
    return `<strong>${e}</strong>`;
  }
  em(e) {
    return `<em>${e}</em>`;
  }
  codespan(e) {
    return `<code>${e}</code>`;
  }
  br() {
    return "<br>";
  }
  del(e) {
    return `<del>${e}</del>`;
  }
  link(e, t, n) {
    const s = gi(e);
    if (s === null)
      return n;
    e = s;
    let r = '<a href="' + e + '"';
    return t && (r += ' title="' + t + '"'), r += ">" + n + "</a>", r;
  }
  image(e, t, n) {
    const s = gi(e);
    if (s === null)
      return n;
    e = s;
    let r = `<img src="${e}" alt="${n}"`;
    return t && (r += ` title="${t}"`), r += ">", r;
  }
  text(e) {
    return e;
  }
}
class vn {
  // no need for block level renderers
  strong(e) {
    return e;
  }
  em(e) {
    return e;
  }
  codespan(e) {
    return e;
  }
  del(e) {
    return e;
  }
  html(e) {
    return e;
  }
  text(e) {
    return e;
  }
  link(e, t, n) {
    return "" + n;
  }
  image(e, t, n) {
    return "" + n;
  }
  br() {
    return "";
  }
}
class se {
  constructor(e) {
    R(this, "options");
    R(this, "renderer");
    R(this, "textRenderer");
    this.options = e || Te, this.options.renderer = this.options.renderer || new Tt(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new vn();
  }
  /**
   * Static Parse Method
   */
  static parse(e, t) {
    return new se(t).parse(e);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(e, t) {
    return new se(t).parseInline(e);
  }
  /**
   * Parse Loop
   */
  parse(e, t = !0) {
    let n = "";
    for (let s = 0; s < e.length; s++) {
      const r = e[s];
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[r.type]) {
        const o = r, c = this.options.extensions.renderers[o.type].call({ parser: this }, o);
        if (c !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(o.type)) {
          n += c || "";
          continue;
        }
      }
      switch (r.type) {
        case "space":
          continue;
        case "hr": {
          n += this.renderer.hr();
          continue;
        }
        case "heading": {
          const o = r;
          n += this.renderer.heading(this.parseInline(o.tokens), o.depth, vr(this.parseInline(o.tokens, this.textRenderer)));
          continue;
        }
        case "code": {
          const o = r;
          n += this.renderer.code(o.text, o.lang, !!o.escaped);
          continue;
        }
        case "table": {
          const o = r;
          let c = "", l = "";
          for (let p = 0; p < o.header.length; p++)
            l += this.renderer.tablecell(this.parseInline(o.header[p].tokens), { header: !0, align: o.align[p] });
          c += this.renderer.tablerow(l);
          let h = "";
          for (let p = 0; p < o.rows.length; p++) {
            const f = o.rows[p];
            l = "";
            for (let u = 0; u < f.length; u++)
              l += this.renderer.tablecell(this.parseInline(f[u].tokens), { header: !1, align: o.align[u] });
            h += this.renderer.tablerow(l);
          }
          n += this.renderer.table(c, h);
          continue;
        }
        case "blockquote": {
          const o = r, c = this.parse(o.tokens);
          n += this.renderer.blockquote(c);
          continue;
        }
        case "list": {
          const o = r, c = o.ordered, l = o.start, h = o.loose;
          let p = "";
          for (let f = 0; f < o.items.length; f++) {
            const u = o.items[f], _ = u.checked, C = u.task;
            let E = "";
            if (u.task) {
              const L = this.renderer.checkbox(!!_);
              h ? u.tokens.length > 0 && u.tokens[0].type === "paragraph" ? (u.tokens[0].text = L + " " + u.tokens[0].text, u.tokens[0].tokens && u.tokens[0].tokens.length > 0 && u.tokens[0].tokens[0].type === "text" && (u.tokens[0].tokens[0].text = L + " " + u.tokens[0].tokens[0].text)) : u.tokens.unshift({
                type: "text",
                text: L + " "
              }) : E += L + " ";
            }
            E += this.parse(u.tokens, h), p += this.renderer.listitem(E, C, !!_);
          }
          n += this.renderer.list(p, c, l);
          continue;
        }
        case "html": {
          const o = r;
          n += this.renderer.html(o.text, o.block);
          continue;
        }
        case "paragraph": {
          const o = r;
          n += this.renderer.paragraph(this.parseInline(o.tokens));
          continue;
        }
        case "text": {
          let o = r, c = o.tokens ? this.parseInline(o.tokens) : o.text;
          for (; s + 1 < e.length && e[s + 1].type === "text"; )
            o = e[++s], c += `
` + (o.tokens ? this.parseInline(o.tokens) : o.text);
          n += t ? this.renderer.paragraph(c) : c;
          continue;
        }
        default: {
          const o = 'Token with "' + r.type + '" type was not found.';
          if (this.options.silent)
            return console.error(o), "";
          throw new Error(o);
        }
      }
    }
    return n;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(e, t) {
    t = t || this.renderer;
    let n = "";
    for (let s = 0; s < e.length; s++) {
      const r = e[s];
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[r.type]) {
        const o = this.options.extensions.renderers[r.type].call({ parser: this }, r);
        if (o !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(r.type)) {
          n += o || "";
          continue;
        }
      }
      switch (r.type) {
        case "escape": {
          const o = r;
          n += t.text(o.text);
          break;
        }
        case "html": {
          const o = r;
          n += t.html(o.text);
          break;
        }
        case "link": {
          const o = r;
          n += t.link(o.href, o.title, this.parseInline(o.tokens, t));
          break;
        }
        case "image": {
          const o = r;
          n += t.image(o.href, o.title, o.text);
          break;
        }
        case "strong": {
          const o = r;
          n += t.strong(this.parseInline(o.tokens, t));
          break;
        }
        case "em": {
          const o = r;
          n += t.em(this.parseInline(o.tokens, t));
          break;
        }
        case "codespan": {
          const o = r;
          n += t.codespan(o.text);
          break;
        }
        case "br": {
          n += t.br();
          break;
        }
        case "del": {
          const o = r;
          n += t.del(this.parseInline(o.tokens, t));
          break;
        }
        case "text": {
          const o = r;
          n += t.text(o.text);
          break;
        }
        default: {
          const o = 'Token with "' + r.type + '" type was not found.';
          if (this.options.silent)
            return console.error(o), "";
          throw new Error(o);
        }
      }
    }
    return n;
  }
}
class Ze {
  constructor(e) {
    R(this, "options");
    this.options = e || Te;
  }
  /**
   * Process markdown before marked
   */
  preprocess(e) {
    return e;
  }
  /**
   * Process HTML after marked is finished
   */
  postprocess(e) {
    return e;
  }
}
R(Ze, "passThroughHooks", /* @__PURE__ */ new Set([
  "preprocess",
  "postprocess"
]));
var tt, dn, kt, Hi;
class Tr {
  constructor(...e) {
    Vt(this, tt);
    Vt(this, kt);
    R(this, "defaults", bn());
    R(this, "options", this.setOptions);
    R(this, "parse", lt(this, tt, dn).call(this, ie.lex, se.parse));
    R(this, "parseInline", lt(this, tt, dn).call(this, ie.lexInline, se.parseInline));
    R(this, "Parser", se);
    R(this, "parser", se.parse);
    R(this, "Renderer", Tt);
    R(this, "TextRenderer", vn);
    R(this, "Lexer", ie);
    R(this, "lexer", ie.lex);
    R(this, "Tokenizer", xt);
    R(this, "Hooks", Ze);
    this.use(...e);
  }
  /**
   * Run callback for every token
   */
  walkTokens(e, t) {
    var s, r;
    let n = [];
    for (const o of e)
      switch (n = n.concat(t.call(this, o)), o.type) {
        case "table": {
          const c = o;
          for (const l of c.header)
            n = n.concat(this.walkTokens(l.tokens, t));
          for (const l of c.rows)
            for (const h of l)
              n = n.concat(this.walkTokens(h.tokens, t));
          break;
        }
        case "list": {
          const c = o;
          n = n.concat(this.walkTokens(c.items, t));
          break;
        }
        default: {
          const c = o;
          (r = (s = this.defaults.extensions) == null ? void 0 : s.childTokens) != null && r[c.type] ? this.defaults.extensions.childTokens[c.type].forEach((l) => {
            n = n.concat(this.walkTokens(c[l], t));
          }) : c.tokens && (n = n.concat(this.walkTokens(c.tokens, t)));
        }
      }
    return n;
  }
  use(...e) {
    const t = this.defaults.extensions || { renderers: {}, childTokens: {} };
    return e.forEach((n) => {
      const s = { ...n };
      if (s.async = this.defaults.async || s.async || !1, n.extensions && (n.extensions.forEach((r) => {
        if (!r.name)
          throw new Error("extension name required");
        if ("renderer" in r) {
          const o = t.renderers[r.name];
          o ? t.renderers[r.name] = function(...c) {
            let l = r.renderer.apply(this, c);
            return l === !1 && (l = o.apply(this, c)), l;
          } : t.renderers[r.name] = r.renderer;
        }
        if ("tokenizer" in r) {
          if (!r.level || r.level !== "block" && r.level !== "inline")
            throw new Error("extension level must be 'block' or 'inline'");
          const o = t[r.level];
          o ? o.unshift(r.tokenizer) : t[r.level] = [r.tokenizer], r.start && (r.level === "block" ? t.startBlock ? t.startBlock.push(r.start) : t.startBlock = [r.start] : r.level === "inline" && (t.startInline ? t.startInline.push(r.start) : t.startInline = [r.start]));
        }
        "childTokens" in r && r.childTokens && (t.childTokens[r.name] = r.childTokens);
      }), s.extensions = t), n.renderer) {
        const r = this.defaults.renderer || new Tt(this.defaults);
        for (const o in n.renderer) {
          const c = n.renderer[o], l = o, h = r[l];
          r[l] = (...p) => {
            let f = c.apply(r, p);
            return f === !1 && (f = h.apply(r, p)), f || "";
          };
        }
        s.renderer = r;
      }
      if (n.tokenizer) {
        const r = this.defaults.tokenizer || new xt(this.defaults);
        for (const o in n.tokenizer) {
          const c = n.tokenizer[o], l = o, h = r[l];
          r[l] = (...p) => {
            let f = c.apply(r, p);
            return f === !1 && (f = h.apply(r, p)), f;
          };
        }
        s.tokenizer = r;
      }
      if (n.hooks) {
        const r = this.defaults.hooks || new Ze();
        for (const o in n.hooks) {
          const c = n.hooks[o], l = o, h = r[l];
          Ze.passThroughHooks.has(o) ? r[l] = (p) => {
            if (this.defaults.async)
              return Promise.resolve(c.call(r, p)).then((u) => h.call(r, u));
            const f = c.call(r, p);
            return h.call(r, f);
          } : r[l] = (...p) => {
            let f = c.apply(r, p);
            return f === !1 && (f = h.apply(r, p)), f;
          };
        }
        s.hooks = r;
      }
      if (n.walkTokens) {
        const r = this.defaults.walkTokens, o = n.walkTokens;
        s.walkTokens = function(c) {
          let l = [];
          return l.push(o.call(this, c)), r && (l = l.concat(r.call(this, c))), l;
        };
      }
      this.defaults = { ...this.defaults, ...s };
    }), this;
  }
  setOptions(e) {
    return this.defaults = { ...this.defaults, ...e }, this;
  }
}
tt = new WeakSet(), dn = function(e, t) {
  return (n, s) => {
    const r = { ...s }, o = { ...this.defaults, ...r };
    this.defaults.async === !0 && r.async === !1 && (o.silent || console.warn("marked(): The async option was set to true by an extension. The async: false option sent to parse will be ignored."), o.async = !0);
    const c = lt(this, kt, Hi).call(this, !!o.silent, !!o.async);
    if (typeof n > "u" || n === null)
      return c(new Error("marked(): input parameter is undefined or null"));
    if (typeof n != "string")
      return c(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
    if (o.hooks && (o.hooks.options = o), o.async)
      return Promise.resolve(o.hooks ? o.hooks.preprocess(n) : n).then((l) => e(l, o)).then((l) => o.walkTokens ? Promise.all(this.walkTokens(l, o.walkTokens)).then(() => l) : l).then((l) => t(l, o)).then((l) => o.hooks ? o.hooks.postprocess(l) : l).catch(c);
    try {
      o.hooks && (n = o.hooks.preprocess(n));
      const l = e(n, o);
      o.walkTokens && this.walkTokens(l, o.walkTokens);
      let h = t(l, o);
      return o.hooks && (h = o.hooks.postprocess(h)), h;
    } catch (l) {
      return c(l);
    }
  };
}, kt = new WeakSet(), Hi = function(e, t) {
  return (n) => {
    if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
      const s = "<p>An error occurred:</p><pre>" + X(n.message + "", !0) + "</pre>";
      return t ? Promise.resolve(s) : s;
    }
    if (t)
      return Promise.reject(n);
    throw n;
  };
};
const xe = new Tr();
function A(i, e) {
  return xe.parse(i, e);
}
A.options = A.setOptions = function(i) {
  return xe.setOptions(i), A.defaults = xe.defaults, Pi(A.defaults), A;
};
A.getDefaults = bn;
A.defaults = Te;
A.use = function(...i) {
  return xe.use(...i), A.defaults = xe.defaults, Pi(A.defaults), A;
};
A.walkTokens = function(i, e) {
  return xe.walkTokens(i, e);
};
A.parseInline = xe.parseInline;
A.Parser = se;
A.parser = se.parse;
A.Renderer = Tt;
A.TextRenderer = vn;
A.Lexer = ie;
A.lexer = ie.lex;
A.Tokenizer = xt;
A.Hooks = Ze;
A.parse = A;
A.options;
A.setOptions;
A.use;
A.walkTokens;
A.parseInline;
se.parse;
ie.lex;
var kr = Object.defineProperty, Cr = Object.getOwnPropertyDescriptor, $t = (i, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? Cr(e, t) : e, r = i.length - 1, o; r >= 0; r--)
    (o = i[r]) && (s = (n ? o(e, t, s) : o(s)) || s);
  return n && s && kr(e, t, s), s;
};
let et = class extends F {
  constructor() {
    super(...arguments), this.url = void 0, this.previewContent = void 0, this.loading = !1;
  }
  retrieveMarkdown() {
    this.url && fetch(this.url).then((i) => i.text()).then((i) => {
      this.previewContent = A.parse(i);
    }).finally(() => {
      this.loading = !1;
    });
  }
  willUpdate(i) {
    this.url && i.has("url") && i.get("url") !== this.url && this.url.endsWith(".md") && (this.loading = !0, this.retrieveMarkdown());
  }
  renderContent() {
    return this.url ? w`
        ${this.previewContent ? w` ${vt(this.previewContent)}` : w` <iframe title="Preview" src="${this.url}" width="100%" height="850px" sandbox />`}
      ` : w``;
  }
  render() {
    return w`
      ${this.loading ? w`<loading-indicator label="${T.LOADING_TEXT}"></loading-indicator>` : this.renderContent()}
    `;
  }
};
$t([
  x({ type: String })
], et.prototype, "url", 2);
$t([
  Q()
], et.prototype, "previewContent", 2);
$t([
  Q()
], et.prototype, "loading", 2);
et = $t([
  J("document-previewer")
], et);
const Ar = oe`
  .subheadline--small {
    font-size: 12px;
    display: inline-block;
  }
  .items__list {
    border-top: none;
    padding: 0 var(--d-base);
    margin: var(--d-small) 0;
    display: block;
  }
  .items__listItem {
    display: inline-block;
    background-color: var(--c-accent-light);
    border-radius: var(--radius-small);
    text-decoration: none;
    padding: var(--d-xsmall);
    margin-top: 5px;
    font-size: var(--font-small);
  }
  .items__listItem.active {
    background-color: var(--c-accent-high);
  }
  .items__listItem:not(first-child) {
    margin-left: 5px;
  }
  .items__link {
    text-decoration: none;
    color: var(--text-color);
  }
  .items__listItem.active .items__link {
    color: var(--c-white);
  }
`;
var Er = Object.defineProperty, $r = Object.getOwnPropertyDescriptor, St = (i, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? $r(e, t) : e, r = i.length - 1, o; r >= 0; r--)
    (o = i[r]) && (s = (n ? o(e, t, s) : o(s)) || s);
  return n && s && Er(e, t, s), s;
};
let Me = class extends F {
  constructor() {
    super(...arguments), this.label = void 0, this.citations = void 0, this.selectedCitation = void 0;
  }
  handleCitationClick(i, e) {
    e.preventDefault(), this.selectedCitation = i;
    const t = new CustomEvent("on-citation-click", {
      detail: {
        citation: i
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(t);
  }
  compareCitation(i, e) {
    return !!(i && e && i.text === e.text);
  }
  renderCitation(i) {
    return i && i.length > 0 ? w`
        <ol class="items__list">
          ${this.label ? w`<h3 class="subheadline--small">${this.label}</h3>` : ""}
          ${i.map(
      (e) => w`
              <li class="items__listItem ${this.compareCitation(e, this.selectedCitation) ? "active" : ""}">
                <a
                  class="items__link"
                  href="#"
                  data-testid="citation"
                  @click="${(t) => this.handleCitationClick(e, t)}"
                  >${e.ref}. ${e.text}</a
                >
              </li>
            `
    )}
        </ol>
      ` : "";
  }
  render() {
    return this.renderCitation(this.citations);
  }
};
Me.styles = [Ar];
St([
  x({ type: String })
], Me.prototype, "label", 2);
St([
  x({ type: Array })
], Me.prototype, "citations", 2);
St([
  x({ type: Object })
], Me.prototype, "selectedCitation", 2);
Me = St([
  J("citation-list")
], Me);
const Sr = oe`
  ul {
    margin-block-start: 0;
    margin-block-end: 0;
  }
  @keyframes chatmessageanimation {
    0% {
      opacity: 0.5;
      top: 150px;
    }
    100% {
      opacity: 1;
      top: 0;
    }
  }
  .chat__header--button {
    display: flex;
    align-items: center;
  }
  .chat__header {
    display: flex;
    align-items: top;
    justify-content: flex-end;
    padding: var(--d-base);
  }
  .chat__header--button {
    margin-right: var(--d-base);
  }
  .chat__list {
    color: var(--text-color);
    display: flex;
    flex-direction: column;
    list-style-position: inside;
    padding-inline-start: 0;
  }
  .chat__footer {
    width: 100%;
    height: calc(var(--d-large) + var(--d-base));
  }
  .chat__listItem {
    max-width: var(--width-wide);
    min-width: var(--width-base);
    display: flex;
    flex-direction: column;
    height: auto;

    @media (min-width: 768px) {
      max-width: 55%;
      min-width: var(--width-narrow);
    }
  }
  .chat__txt {
    animation: chatmessageanimation 0.5s ease-in-out;
    background-color: var(--c-secondary);
    color: var(--text-color);
    border-radius: var(--radius-base);
    margin-top: 8px;
    word-wrap: break-word;
    margin-block-end: 0;
    position: relative;
    box-shadow: var(--shadow);
    border: var(--border-thin) solid var(--c-light-gray);
  }
  .chat__txt.error {
    border: var(--border-base) solid var(--error-color);
    color: var(--error-color);
    padding: var(--d-base);
    background: var(--c-error-background);
  }
  .chat__txt.user-message {
    background: linear-gradient(to left, var(--c-accent-dark), var(--c-accent-high));
    color: var(--c-white);
    border: var(--border-thin) solid var(--c-accent-light);
  }
  .chat__listItem.user-message {
    align-self: flex-end;
  }
  .chat__txt--entry {
    padding: 0 var(--d-base);
  }
  .chat__txt--info {
    font-size: smaller;
    font-style: italic;
    margin: 0;
    margin-top: var(--border-thin);
    visibility: hidden;
  }
  .user-message .chat__txt--info {
    text-align: right;
  }
  .items__listWrapper {
    border-top: var(--border-thin) solid var(--c-light-gray);
    display: grid;
    padding: 0 var(--d-base);
    grid-template-columns: 1fr 18fr;
  }
  .items__listWrapper svg {
    fill: var(--c-accent-high);
    width: var(--d-large);
    margin: var(--d-large) auto;
  }
  svg {
    height: auto;
    fill: var(--text-color);
  }
  .items__list.followup {
    display: flex;
    flex-direction: row;
    padding: var(--d-base);
    list-style-type: none;
    flex-wrap: wrap;
  }
  .items__list.steps {
    padding: 0 var(--d-base) 0 var(--d-xlarge);
    list-style-type: disc;
  }
  .chat__citations {
    border-top: var(--border-thin) solid var(--c-light-gray);
  }
  .items__list {
    margin: var(--d-small) 0;
    display: block;
    padding: 0 var(--d-base);
  }
  .items__listItem--followup {
    cursor: pointer;
    padding: 0 var(--d-xsmall);
    border-radius: var(--radius-base);
    border: var(--border-thin) solid var(--c-accent-high);
    margin: var(--d-xsmall);
    transition: background-color 0.3s ease-in-out;
  }
  .items__listItem--followup:hover,
  .items__listItem--followup:focus {
    background-color: var(--c-accent-light);
    cursor: pointer;
  }
  .items__link {
    text-decoration: none;
    color: var(--text-color);
  }
  .steps .items__listItem--step {
    padding: var(--d-xsmall) 0;
    font-size: var(--font-base);
    line-height: 1;
  }
  .followup .items__link {
    color: var(--c-accent-high);
    display: block;
    padding: var(--d-xsmall) 0;
    border-bottom: var(--border-thin) solid var(--c-light-gray);
    font-size: var(--font-small);
  }
  .citation {
    background-color: var(--c-accent-light);
    border-radius: 3px;
    padding: calc(var(--d-small) / 5);
    margin-left: 3px;
  }
`, Rr = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048">\r
  <path d="M1491 595l90 90-749 749-365-365 90-90 275 275 659-659zM1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32z" />\r
</svg>`, Ir = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048">\r
  <path d="M1920 805v1243H640v-384H128V0h859l384 384h128l421 421zm-384-37h165l-165-165v165zM640 384h549L933 128H256v1408h384V384zm1152 512h-384V512H768v1408h1024V896z" />\r
</svg>`, Lr = `<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">\r
  <path d="M12.5001 3C6.70106 3 2.00005 7.70101 2.00005 13.5C2.00005 14.7989 2.23632 16.044 2.66849 17.1938C2.79635 17.534 2.94135 17.8658 3.10245 18.1881L2.0527 22.1058C1.75384 23.2212 2.77447 24.2418 3.88982 23.943L7.80465 22.894C9.2185 23.6019 10.8141 24 12.5001 24C18.299 24 23.0001 19.299 23.0001 13.5C23.0001 7.70101 18.299 3 12.5001 3ZM5.04572 17.5882C4.37944 16.3761 4.00005 14.9839 4.00005 13.5C4.00005 8.80558 7.80563 5 12.5001 5C17.1945 5 21.0001 8.80558 21.0001 13.5C21.0001 18.1944 17.1945 22 12.5001 22C11.0137 22 9.61924 21.6193 8.4058 20.951C8.1796 20.8264 7.91397 20.7941 7.66452 20.861L4.2087 21.787L5.13533 18.3287C5.2021 18.0796 5.16999 17.8142 5.04572 17.5882ZM14.4549 25.3417C13.8187 25.446 13.1657 25.5002 12.5 25.5002C12.2132 25.5002 11.9287 25.4901 11.647 25.4703C13.5704 27.6358 16.3758 29.0002 19.5 29.0002C21.186 29.0002 22.7815 28.6021 24.1954 27.8941L28.1102 28.9431C29.2255 29.242 30.2462 28.2214 29.9473 27.106L28.8976 23.1883C29.0587 22.8659 29.2037 22.5341 29.3315 22.194C29.7637 21.0442 30 19.799 30 18.5002C30 14.1361 27.3376 10.3939 23.5485 8.80908C23.9114 9.6628 24.1783 10.5672 24.3355 11.5087C26.5498 13.0431 28 15.6023 28 18.5002C28 19.984 27.6206 21.3763 26.9543 22.5883C26.83 22.8144 26.7979 23.0797 26.8647 23.3289L27.7913 26.7871L24.3355 25.8611C24.086 25.7943 23.8204 25.8266 23.5942 25.9511C22.3808 26.6195 20.9863 27.0002 19.5 27.0002C17.611 27.0002 15.866 26.384 14.4549 25.3417ZM11.5 15C11.5 15.55 11.95 16 12.5 16C13.05 16 13.5 15.55 13.5 15C13.5 14.0992 14.0096 13.5217 14.6019 12.8505L14.62 12.83C15.27 12.09 16 11.21 16 10C16 8.79 15.07 7 12.5 7C9.93 7 9 8.79 9 10C9 10.55 9.45 11 10 11C10.55 11 11 10.55 11 10C11 9.83 11.07 9 12.5 9C13.82 9 13.99 9.71 14 10C14 10.48 13.68 10.86 13.12 11.5L13.1009 11.5217C12.3842 12.3378 11.5 13.3447 11.5 15ZM13.75 18.75C13.75 19.4404 13.1904 20 12.5 20C11.8096 20 11.25 19.4404 11.25 18.75C11.25 18.0596 11.8096 17.5 12.5 17.5C13.1904 17.5 13.75 18.0596 13.75 18.75Z" />\r
</svg>`, Or = oe`
  button {
    color: var(--text-color);
    text-decoration: underline;
    border: var(--border-thin) solid var(--c-accent-dark);
    text-decoration: none;
    border-radius: var(--radius-small);
    background: var(--c-white);
    display: flex;
    align-items: center;
    margin-left: 5px;
    opacity: 1;
    padding: var(--d-xsmall);
    transition: all 0.3s ease-in-out;
    position: relative;
    cursor: pointer;
  }
  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  span {
    font-size: smaller;
    transition: all 0.3s ease-out 0s;
    position: absolute;
    text-align: right;
    top: -80%;
    background: var(--c-accent-dark);
    color: var(--c-white);
    opacity: 0;
    right: 0;
    padding: var(--d-xsmall) var(--d-small);
    border-radius: var(--radius-small);
    font-weight: bold;
    word-wrap: nowrap;
  }
  span::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: var(--border-thick) solid var(--c-accent-dark);
    bottom: -8px;
    right: 5px;
  }
  svg {
    fill: currentColor;
    padding: var(--d-xsmall);
    width: var(--d-base);
    height: var(--d-base);
  }
  button:hover > span,
  button:focus > span {
    display: inline-block;
    opacity: 1;
  }
  button:hover,
  button:focus,
  button:hover > svg,
  button:focus > svg {
    background-color: var(--c-light-gray);
    border-radius: var(--radius-small);
    transition: background 0.3s ease-in-out;
  }
`;
var Dr = Object.defineProperty, Pr = Object.getOwnPropertyDescriptor, Ue = (i, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? Pr(e, t) : e, r = i.length - 1, o; r >= 0; r--)
    (o = i[r]) && (s = (n ? o(e, t, s) : o(s)) || s);
  return n && s && Dr(e, t, s), s;
};
let pe = class extends F {
  constructor() {
    super(...arguments), this.label = "", this.svgIcon = "", this.isDisabled = !1, this.actionId = "", this.tooltip = void 0;
  }
  render() {
    return w`
      <button title="${this.label}" data-testid="${this.actionId}" ?disabled="${this.isDisabled}">
        <span>${this.tooltip ?? this.label}</span>
        ${ne(this.svgIcon)}
      </button>
    `;
  }
};
pe.styles = [Or];
Ue([
  x({ type: String })
], pe.prototype, "label", 2);
Ue([
  x({ type: String })
], pe.prototype, "svgIcon", 2);
Ue([
  x({ type: Boolean })
], pe.prototype, "isDisabled", 2);
Ue([
  x({ type: String })
], pe.prototype, "actionId", 2);
Ue([
  x({ type: String })
], pe.prototype, "tooltip", 2);
pe = Ue([
  J("chat-action-button")
], pe);
var Nr = Object.defineProperty, Mr = Object.getOwnPropertyDescriptor, de = (i, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? Mr(e, t) : e, r = i.length - 1, o; r >= 0; r--)
    (o = i[r]) && (s = (n ? o(e, t, s) : o(s)) || s);
  return n && s && Nr(e, t, s), s;
};
let re = class extends F {
  constructor() {
    super(...arguments), this.chatThread = [], this.actionButtons = [], this.isDisabled = !1, this.isProcessingResponse = !1, this.isResponseCopied = !1, this.selectedCitation = void 0;
  }
  // Copy response to clipboard
  copyResponseToClipboard(i) {
    const e = Oi(i);
    navigator.clipboard.writeText(e), this.isResponseCopied = !0;
  }
  actionButtonClicked(i, e, t) {
    t.preventDefault();
    const n = new CustomEvent("on-action-button-click", {
      detail: {
        id: i.id,
        chatThreadEntry: e
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(n);
  }
  // debounce dispatching must-scroll event
  debounceScrollIntoView() {
    let i = 0;
    clearTimeout(i), i = setTimeout(() => {
      this.chatFooter && this.chatFooter.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 500);
  }
  handleFollowupQuestionClick(i, e, t) {
    t.preventDefault();
    const n = new CustomEvent("on-followup-click", {
      detail: {
        question: i,
        chatThreadEntry: e
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(n);
  }
  handleCitationClick(i, e, t) {
    t.preventDefault(), this.selectedCitation = i;
    const n = new CustomEvent("on-citation-click", {
      detail: {
        citation: i,
        chatThreadEntry: e
      },
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(n);
  }
  renderResponseActions(i) {
    return w`
      <header class="chat__header">
        <div class="chat__header--button">
          ${this.actionButtons.map(
      (e) => w`
              <chat-action-button
                .label="${e.label}"
                .svgIcon="${e.svgIcon}"
                .isDisabled="${e.isDisabled}"
                .actionId="${e.id}"
                @click="${(t) => this.actionButtonClicked(e, i, t)}"
              ></chat-action-button>
            `
    )}
          <chat-action-button
            .label="${T.COPY_RESPONSE_BUTTON_LABEL_TEXT}"
            .svgIcon="${this.isResponseCopied ? Rr : Ir}"
            .isDisabled="${this.isDisabled}"
            actionId="copy-to-clipboard"
            .tooltip="${this.isResponseCopied ? T.COPIED_SUCCESSFULLY_MESSAGE : T.COPY_RESPONSE_BUTTON_LABEL_TEXT}"
            @click="${this.copyResponseToClipboard}"
          ></chat-action-button>
        </div>
      </header>
    `;
  }
  renderTextEntry(i) {
    const e = [w`<p class="chat__txt--entry">${vt(i.value)}</p>`];
    return i.followingSteps && i.followingSteps.length > 0 && e.push(w`
        <ol class="items__list steps">
          ${i.followingSteps.map(
      (t) => w` <li class="items__listItem--step">${vt(t)}</li> `
    )}
        </ol>
      `), this.isProcessingResponse && this.debounceScrollIntoView(), w`<div class="chat_txt--entry-container">${e}</div>`;
  }
  renderCitation(i) {
    const e = i.citations;
    return e && e.length > 0 ? w`
        <div class="chat__citations">
          <citation-list
            .citations="${e}"
            .label="${T.CITATIONS_LABEL}"
            .selectedCitation=${this.selectedCitation}
            @on-citation-click="${(t) => this.handleCitationClick(t.detail.citation, i, t)}"
          ></citation-list>
        </div>
      ` : "";
  }
  renderFollowupQuestions(i) {
    const e = i.followupQuestions;
    return e && e.length > 0 ? w`
        <div class="items__listWrapper">
          ${ne(Lr)}
          <ul class="items__list followup">
            ${e.map(
      (t) => w`
                <li class="items__listItem--followup">
                  <a
                    class="items__link"
                    href="#"
                    data-testid="followUpQuestion"
                    @click="${(n) => this.handleFollowupQuestionClick(t, i, n)}"
                    >${t}</a
                  >
                </li>
              `
    )}
          </ul>
        </div>
      ` : "";
  }
  renderError(i) {
    return w`<p class="chat__txt error">${i.message}</p>`;
  }
  render() {
    return w`
      <ul class="chat__list" aria-live="assertive">
        ${this.chatThread.filter((i) => (i.text || []).some((e) => e.value)).map(
      (i) => w`
              <li class="chat__listItem ${i.isUserMessage ? "user-message" : ""}">
                <div class="chat__txt ${i.isUserMessage ? "user-message" : ""}">
                  ${i.isUserMessage ? "" : this.renderResponseActions(i)}
                  ${i.text.map((e) => this.renderTextEntry(e))} ${this.renderCitation(i)}
                  ${this.renderFollowupQuestions(i)} ${i.error ? this.renderError(i.error) : ""}
                </div>
                <p class="chat__txt--info">
                  <span class="timestamp">${i.timestamp}</span>,
                  <span class="user">${i.isUserMessage ? "You" : T.USER_IS_BOT}</span>
                </p>
              </li>
            `
    )}
      </ul>
      <div class="chat__footer" id="chat-list-footer">
        <!-- Do not delete this element. It is used for auto-scrolling -->
      </div>
    `;
  }
};
re.styles = [Sr];
de([
  x({ type: Array })
], re.prototype, "chatThread", 2);
de([
  x({ type: Array })
], re.prototype, "actionButtons", 2);
de([
  x({ type: Boolean })
], re.prototype, "isDisabled", 2);
de([
  x({ type: Boolean })
], re.prototype, "isProcessingResponse", 2);
de([
  Q()
], re.prototype, "isResponseCopied", 2);
de([
  ki("#chat-list-footer")
], re.prototype, "chatFooter", 2);
de([
  x({ type: Object })
], re.prototype, "selectedCitation", 2);
re = de([
  J("chat-thread-component")
], re);
async function Hr({ question: i, type: e, overrides: t, messages: n }, { method: s, url: r, stream: o, signal: c }) {
  return await fetch(`${r}/${e}`, {
    method: s,
    headers: {
      "Content-Type": "application/json"
    },
    signal: c,
    body: JSON.stringify({
      messages: [
        ...n ?? [],
        {
          content: i,
          role: "user"
        }
      ],
      context: {
        ...t,
        approach: "rtr"
      },
      stream: e === "chat" ? o : !1
    })
  });
}
async function Ur(i, e) {
  const t = await Hr(i, e);
  if (i.type === "ask" ? !1 : e.stream)
    return t;
  const s = await t.json();
  if (t.status > 299 || !t.ok)
    throw new pn(t.statusText, t.status) || "API Response Error";
  return s;
}
class zr extends TransformStream {
  constructor() {
    let e;
    super({
      start: (t) => {
        e = t;
      },
      transform: (t) => {
        const n = t.split(`
`).filter(Boolean);
        for (const s of n)
          try {
            this.buffer += s, e.enqueue(JSON.parse(this.buffer)), this.buffer = "";
          } catch {
          }
      }
    }), this.buffer = "";
  }
}
function Br(i) {
  return i == null ? void 0 : i.pipeThrough(new TextDecoderStream()).pipeThrough(new zr()).getReader();
}
async function* qr(i) {
  if (!i)
    throw new Error("No response body or body is not readable");
  let e, t;
  for (; { value: e, done: t } = await i.read(), !t; )
    yield new Promise((n) => {
      setTimeout(() => {
        n(e);
      }, T.BOT_TYPING_EFFECT_INTERVAL);
    });
}
function io(i) {
  i && i.cancel();
}
async function Fr({
  chatEntry: i,
  apiResponseBody: e,
  signal: t,
  onChunkRead: n,
  onCancel: s
}) {
  const r = Br(e), o = qr(r), c = [], l = [], h = [];
  let p = !1, f = !1, u = !1, _ = 0, C = 0, E = 0, L = {
    ...i
  };
  for await (const G of o) {
    if (t.aborted) {
      s();
      return;
    }
    if (G.error)
      throw new pn(G.message, G.statusCode);
    if (G.choices[0].finish_reason === "content_filter")
      throw new pn("Content filtered", 400);
    const { content: ee, context: S } = G.choices[0].delta;
    if (S != null && S.data_points) {
      L.dataPoints = S.data_points ?? [], L.thoughts = S.thoughts ?? "";
      continue;
    }
    let $ = ee ?? "";
    if ($ === "")
      continue;
    c.push($);
    let N = 0;
    if (!u && $.includes("Next") || $.includes("<<")) {
      u = !0, h.push($);
      continue;
    } else if (h.length > 0 && $.includes("Question")) {
      u = !0, h.push($);
      continue;
    } else if ($.includes("<<") && u) {
      u = !0;
      continue;
    } else if ($.includes(`>
`)) {
      _ = _ + 1, u = !0;
      continue;
    } else
      u && (u = !0, $ = $.replace(/:?\n/, "").replaceAll(">", ""));
    l.length > 0 && $.includes(".") ? (p = !0, N = l[0], l.length = 0) : $.includes(`

`) && p && (f = !0), N || p || u ? (N && ($ = ""), C = N ? Number(N) - 1 : C, L = Gr({
      chunkValue: $,
      textBlockIndex: E,
      stepIndex: C,
      isFollowupQuestion: u,
      followUpQuestionIndex: _,
      chatEntry: L
    }), f && (p = !1, f = !1, u = !1, C = 0, E++)) : L = Wr({ chunkValue: $, textBlockIndex: E, chatEntry: L });
    const ue = jr(c.join(""));
    L = Vr({ citations: ue, chatEntry: L }), n(L);
  }
}
function Vr({
  citations: i,
  chatEntry: e
}) {
  const t = e, n = (r, o) => {
    const c = i.find((l) => l.text === o);
    return c ? `<sup class="citation">${c.ref}</sup>` : r;
  };
  console.warn("lastMessageEntry", t.text);
  const s = t.text.map((r) => {
    var l;
    const o = r.value.replaceAll(/\[(.*?)]/g, n), c = (l = r.followingSteps) == null ? void 0 : l.map(
      (h) => h.replaceAll(/\[(.*?)]/g, n)
    );
    return {
      value: o,
      followingSteps: c
    };
  });
  return console.trace("citations", s), {
    ...t,
    text: s,
    citations: i
  };
}
function jr(i) {
  const e = /\[(.*?)]/g, t = {};
  let n = 1;
  return i.replaceAll(e, (s, r) => {
    const o = r.trim();
    return t[o] || (t[o] = n++), "";
  }), Object.keys(t).map((s, r) => ({
    ref: r + 1,
    text: s
  }));
}
function Wr({
  chunkValue: i,
  textBlockIndex: e,
  chatEntry: t
}) {
  const { text: n } = t, s = n[e] ?? {
    value: "",
    followingSteps: []
  }, r = (s.value || "") + i;
  return {
    ...t,
    text: Ge(n, e, {
      ...s,
      value: r
    })
  };
}
function Gr({
  chunkValue: i,
  textBlockIndex: e,
  stepIndex: t,
  isFollowupQuestion: n,
  followUpQuestionIndex: s,
  chatEntry: r
}) {
  const { followupQuestions: o, text: c } = r;
  if (n && o) {
    const l = (o[s] || "") + i;
    return {
      ...r,
      followupQuestions: Ge(o, s, l)
    };
  }
  if (c && c[e]) {
    const { followingSteps: l } = c[e];
    if (l) {
      const h = (l[t] || "") + i;
      return {
        ...r,
        text: Ge(c, e, {
          ...c[e],
          followingSteps: Ge(l, t, h)
        })
      };
    }
  }
  return r;
}
class Zr {
  constructor(e) {
    this._generatingAnswer = !1, this._isAwaitingResponse = !1, this._isProcessingResponse = !1, this._processingMessage = void 0, this._abortController = new AbortController(), (this.host = e).addController(this);
  }
  get isAwaitingResponse() {
    return this._isAwaitingResponse;
  }
  get isProcessingResponse() {
    return this._isProcessingResponse;
  }
  get processingMessage() {
    return this._processingMessage;
  }
  get generatingAnswer() {
    return this._generatingAnswer;
  }
  set generatingAnswer(e) {
    this._generatingAnswer = e, this.host.requestUpdate();
  }
  set processingMessage(e) {
    this._processingMessage = e ? {
      ...e
    } : void 0, this.host.requestUpdate();
  }
  set isAwaitingResponse(e) {
    this._isAwaitingResponse = e, this.host.requestUpdate();
  }
  set isProcessingResponse(e) {
    this._isProcessingResponse = e, this.host.requestUpdate();
  }
  hostConnected() {
  }
  hostDisconnected() {
  }
  clear() {
    this._isAwaitingResponse = !1, this._isProcessingResponse = !1, this._generatingAnswer = !1, this.host.requestUpdate();
  }
  reset() {
    this._processingMessage = void 0, this.clear();
  }
  async processResponse(e, t = !1, n = !1) {
    var f, u;
    const s = [], r = [], o = [], c = Zs();
    let l, h;
    const p = async (_, C) => {
      this.processingMessage = {
        id: crypto.randomUUID(),
        text: [
          {
            value: C ? "" : _,
            followingSteps: r
          }
        ],
        followupQuestions: o,
        citations: [...new Set(s)],
        timestamp: c,
        isUserMessage: t,
        thoughts: l,
        dataPoints: h
      }, C && this.processingMessage && (this.isProcessingResponse = !0, this._abortController = new AbortController(), await Fr({
        chatEntry: this.processingMessage,
        signal: this._abortController.signal,
        apiResponseBody: _.body,
        onChunkRead: (E) => {
          E.text && (this.isAwaitingResponse = !1), this.processingMessage = E;
        },
        onCancel: () => {
          this.clear();
        }
      }), this.clear());
    };
    if (t || typeof e == "string")
      await p(e, !1);
    else if (n)
      await p(e, !0);
    else {
      const _ = e.choices[0].message, C = Ws(_.content, [s, r, o]), E = C.replacedText;
      s.push(...C.arrays[0]), r.push(...C.arrays[1]), o.push(...C.arrays[2]), l = ((f = _.context) == null ? void 0 : f.thoughts) ?? "", h = ((u = _.context) == null ? void 0 : u.data_points) ?? [], await p(E, !1);
    }
  }
  async generateAnswer(e, t) {
    const { question: n } = e;
    if (n)
      try {
        this.generatingAnswer = !0, e.type === "chat" && await this.processResponse(n, !0, !1), this.isAwaitingResponse = !0, this.processingMessage = void 0;
        const s = await Ur(e, t);
        await this.processResponse(s, !1, t.stream);
      } catch (s) {
        const r = s, o = {
          message: (r == null ? void 0 : r.code) === 400 ? T.INVALID_REQUEST_ERROR : T.API_ERROR_MESSAGE
        };
        this.processingMessage || await this.processResponse("", !1, !1), this.processingMessage && (this.processingMessage = {
          ...this.processingMessage,
          error: o
        });
      } finally {
        this.clear();
      }
  }
  cancelRequest() {
    this._abortController.abort();
  }
}
const Xr = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
  <path d="M15.4,4.9a8.3,8.3,0,0,1,0,6.2,9.009,9.009,0,0,1-1.7,2.6,9.009,9.009,0,0,1-2.6,1.7A8.112,8.112,0,0,1,8,16a7.509,7.509,0,0,1-2.6-.4,7.609,7.609,0,0,1-2.3-1.3,7.31,7.31,0,0,1-1.7-1.8L.7,11.4c-.1-.4-.3-.8-.4-1.3l1-.2a7.207,7.207,0,0,0,.9,2,8.716,8.716,0,0,0,1.6,1.7,6.9,6.9,0,0,0,1.9,1A6.184,6.184,0,0,0,8,15l1.9-.2,1.6-.8a4.9,4.9,0,0,0,1.4-1.1A4.9,4.9,0,0,0,14,11.5a7.976,7.976,0,0,0,.8-1.6A12.233,12.233,0,0,0,15,8a12.233,12.233,0,0,0-.2-1.9A7.976,7.976,0,0,0,14,4.5a4.9,4.9,0,0,0-1.1-1.4A4.9,4.9,0,0,0,11.5,2a4.61,4.61,0,0,0-1.6-.7A6.283,6.283,0,0,0,8,1a6.879,6.879,0,0,0-2,.3,5.292,5.292,0,0,0-1.7.8A4.708,4.708,0,0,0,2.8,3.4,4.6,4.6,0,0,0,1.7,5H4V6H0V2H1V4.1l.3-.4.3-.5A9.122,9.122,0,0,1,3.3,1.5,7.6,7.6,0,0,1,5.5.4,7.308,7.308,0,0,1,8,0a8.112,8.112,0,0,1,3.1.6,9.009,9.009,0,0,1,2.6,1.7A9.009,9.009,0,0,1,15.4,4.9Z" />
  <polygon points="8 3 8 7.3 10.9 10.1 10.1 10.9 7 7.7 7 3 8 3" />
</svg>`, Yr = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.75 12C4.75 15.743 7.58642 18.8235 11.2271 19.2093C11.4284 19.9498 11.7573 20.6378 12.1888 21.2481C12.126 21.2494 12.0631 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 11.6174 2.77322 11.2403 2.81834 10.8699C2.88069 10.3581 3.33398 10 3.8496 10C4.44068 10 4.86674 10.5685 4.79864 11.1556C4.76652 11.4326 4.75 11.7144 4.75 12ZM12.8096 13C13.5854 12.1915 14.5683 11.5832 15.6729 11.2603C15.4953 11.0986 15.2592 11 15 11H13V8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V12C11 12.5523 11.4477 13 12 13H12.8096ZM21.2481 12.1888C20.6378 11.7573 19.9498 11.4284 19.2093 11.2271C18.8235 7.58642 15.743 4.75 12 4.75C10.3379 4.75 8.80642 5.30932 7.58352 6.25H8.25C8.80228 6.25 9.25 6.69772 9.25 7.25C9.25 7.80228 8.80228 8.25 8.25 8.25H5.25C4.69772 8.25 4.25 7.80228 4.25 7.25V7H4.21647L4.25 6.94829V4.25C4.25 3.69772 4.69772 3.25 5.25 3.25C5.80228 3.25 6.25 3.69772 6.25 4.25V4.75385C7.82875 3.49939 9.82686 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 12.0631 21.2494 12.126 21.2481 12.1888ZM23 17.5C23 20.5376 20.5376 23 17.5 23C14.4624 23 12 20.5376 12 17.5C12 14.4624 14.4624 12 17.5 12C20.5376 12 23 14.4624 23 17.5ZM15.8536 15.1464C15.6583 14.9512 15.3417 14.9512 15.1464 15.1464C14.9512 15.3417 14.9512 15.6583 15.1464 15.8536L16.7929 17.5L15.1464 19.1464C14.9512 19.3417 14.9512 19.6583 15.1464 19.8536C15.3417 20.0488 15.6583 20.0488 15.8536 19.8536L17.5 18.2071L19.1464 19.8536C19.3417 20.0488 19.6583 20.0488 19.8536 19.8536C20.0488 19.6583 20.0488 19.3417 19.8536 19.1464L18.2071 17.5L19.8536 15.8536C20.0488 15.6583 20.0488 15.3417 19.8536 15.1464C19.6583 14.9512 19.3417 14.9512 19.1464 15.1464L17.5 16.7929L15.8536 15.1464Z" />
</svg>`, Ui = class un {
  constructor(e) {
    this.chatHistory = [], this._showChatHistory = !1, (this.host = e).addController(this);
  }
  get showChatHistory() {
    return this._showChatHistory;
  }
  set showChatHistory(e) {
    this._showChatHistory = e, this.host.requestUpdate();
  }
  hostConnected() {
    const e = localStorage.getItem(un.CHATHISTORY_ID);
    if (e) {
      const t = JSON.parse(atob(e)), n = t.map((r, o) => {
        if (r.isUserMessage)
          return o;
      }).filter((r) => r !== void 0).slice(-Li), s = n.length === 0 ? t : t.slice(n[0]);
      this.chatHistory = s;
    }
  }
  hostDisconnected() {
  }
  saveChatHistory(e) {
    const t = [...this.chatHistory, ...e];
    localStorage.setItem(un.CHATHISTORY_ID, btoa(JSON.stringify(t)));
  }
  handleChatHistoryButtonClick(e) {
    e.preventDefault(), this.showChatHistory = !this.showChatHistory;
  }
  renderHistoryButton(e) {
    return w`
      <chat-action-button
        .label="${this.showChatHistory ? T.HIDE_CHAT_HISTORY_LABEL : T.SHOW_CHAT_HISTORY_LABEL}"
        actionId="chat-history-button"
        @click="${(t) => this.handleChatHistoryButtonClick(t)}"
        .isDisabled="${e == null ? void 0 : e.disabled}"
        .svgIcon="${this.showChatHistory ? Yr : Xr}"
      >
      </chat-action-button>
    `;
  }
};
Ui.CHATHISTORY_ID = "ms-azoaicc:history";
let Qr = Ui;
var Kr = Object.defineProperty, Jr = Object.getOwnPropertyDescriptor, z = (i, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? Jr(e, t) : e, r = i.length - 1, o; r >= 0; r--)
    (o = i[r]) && (s = (n ? o(e, t, s) : o(s)) || s);
  return n && s && Kr(e, t, s), s;
};
let P = class extends F {
  constructor() {
    super(...arguments), this.inputPosition = "sticky", this.interactionModel = "chat", this.apiUrl = sn.url, this.isCustomBranding = T.IS_CUSTOM_BRANDING, this.useStream = sn.stream, this.overrides = {}, this.customStyles = {}, this.currentQuestion = "", this.isDisabled = !1, this.isChatStarted = !1, this.isResetInput = !1, this.chatController = new Zr(this), this.chatHistoryController = new Qr(this), this.isShowingThoughtProcess = !1, this.isDefaultPromptsEnabled = !this.isChatStarted, this.selectedCitation = void 0, this.selectedChatEntry = void 0, this.selectedAsideTab = "tab-thought-process", this.chatThread = [];
  }
  updated(i) {
    super.updated(i), i.has("customStyles") && (this.style.setProperty("--c-accent-high", this.customStyles.AccentHigh), this.style.setProperty("--c-accent-lighter", this.customStyles.AccentLight), this.style.setProperty("--c-accent-dark", this.customStyles.AccentDark), this.style.setProperty("--c-text-color", this.customStyles.TextColor), this.style.setProperty("--c-light-gray", this.customStyles.BackgroundColor), this.style.setProperty("--c-dark-gray", this.customStyles.ForegroundColor), this.style.setProperty("--c-base-gray", this.customStyles.FormBackgroundColor), this.style.setProperty("--radius-base", this.customStyles.BorderRadius), this.style.setProperty("--border-base", this.customStyles.BorderWidth), this.style.setProperty("--font-base", this.customStyles.FontBaseSize));
  }
  // Send the question to the Open AI API and render the answer in the chat
  setQuestionInputValue(i) {
    this.questionInput.value = hi.sanitize(i || ""), this.currentQuestion = this.questionInput.value;
  }
  handleVoiceInput(i) {
    var e;
    i == null || i.preventDefault(), this.setQuestionInputValue((e = i == null ? void 0 : i.detail) == null ? void 0 : e.input);
  }
  handleQuestionInputClick(i) {
    var e;
    i == null || i.preventDefault(), this.setQuestionInputValue((e = i == null ? void 0 : i.detail) == null ? void 0 : e.question);
  }
  handleCitationClick(i) {
    var e, t, n;
    i == null || i.preventDefault(), this.selectedCitation = (e = i == null ? void 0 : i.detail) == null ? void 0 : e.citation, this.isShowingThoughtProcess || ((t = i == null ? void 0 : i.detail) != null && t.chatThreadEntry && (this.selectedChatEntry = (n = i == null ? void 0 : i.detail) == null ? void 0 : n.chatThreadEntry), this.handleExpandAside(), this.selectedAsideTab = "tab-citations");
  }
  getMessageContext() {
    return this.interactionModel === "ask" ? [] : [
      ...this.chatThread,
      // include the history from the previous session if the user has enabled the chat history
      ...this.chatHistoryController.showChatHistory ? this.chatHistoryController.chatHistory : []
    ].map((t) => ({
      content: Oi(t),
      role: t.isUserMessage ? "user" : "assistant"
    }));
  }
  // Handle the click on the chat button and send the question to the API
  async handleUserChatSubmit(i) {
    i.preventDefault(), this.collapseAside(i);
    const e = hi.sanitize(this.questionInput.value);
    this.isChatStarted = !0, this.isDefaultPromptsEnabled = !1, await this.chatController.generateAnswer(
      {
        ...pi,
        overrides: {
          ...pi.overrides,
          ...this.overrides
        },
        question: e,
        type: this.interactionModel,
        messages: this.getMessageContext()
      },
      {
        // use defaults
        ...sn,
        // override if the user has provided different values
        url: this.apiUrl,
        stream: this.useStream
      }
    ), this.interactionModel === "chat" && this.chatHistoryController.saveChatHistory(this.chatThread), this.questionInput.value = "", this.isResetInput = !1;
  }
  // Reset the input field and the current question
  resetInputField(i) {
    i.preventDefault(), this.questionInput.value = "", this.currentQuestion = "", this.isResetInput = !1;
  }
  // Reset the chat and show the default prompts
  resetCurrentChat(i) {
    this.isChatStarted = !1, this.chatThread = [], this.isDisabled = !1, this.isDefaultPromptsEnabled = !0, this.selectedCitation = void 0, this.chatController.reset(), this.chatHistoryController.saveChatHistory(this.chatThread), this.collapseAside(i), this.handleUserChatCancel(i);
  }
  // Show the default prompts when enabled
  showDefaultPrompts(i) {
    this.isDefaultPromptsEnabled || this.resetCurrentChat(i);
  }
  // Handle the change event on the input field
  handleOnInputChange() {
    this.isResetInput = !!this.questionInput.value;
  }
  // Stop generation
  handleUserChatCancel(i) {
    i == null || i.preventDefault(), this.chatController.cancelRequest();
  }
  // show thought process aside
  handleExpandAside(i = void 0) {
    var e, t, n, s;
    i == null || i.preventDefault(), this.isShowingThoughtProcess = !0, this.selectedAsideTab = "tab-thought-process", (t = (e = this.shadowRoot) == null ? void 0 : e.querySelector("#overlay")) == null || t.classList.add("active"), (s = (n = this.shadowRoot) == null ? void 0 : n.querySelector("#chat__containerWrapper")) == null || s.classList.add("aside-open");
  }
  // hide thought process aside
  collapseAside(i) {
    var e, t, n, s;
    i.preventDefault(), this.isShowingThoughtProcess = !1, this.selectedCitation = void 0, (t = (e = this.shadowRoot) == null ? void 0 : e.querySelector("#chat__containerWrapper")) == null || t.classList.remove("aside-open"), (s = (n = this.shadowRoot) == null ? void 0 : n.querySelector("#overlay")) == null || s.classList.remove("active");
  }
  renderChatOrCancelButton() {
    const i = w`<button
      class="chatbox__button"
      data-testid="submit-question-button"
      @click="${this.handleUserChatSubmit}"
      title="${T.CHAT_BUTTON_LABEL_TEXT}"
      ?disabled="${this.isDisabled}"
    >
      ${ne(Ks)}
    </button>`, e = w`<button
      class="chatbox__button"
      data-testid="cancel-question-button"
      @click="${this.handleUserChatCancel}"
      title="${T.CHAT_CANCEL_BUTTON_LABEL_TEXT}"
    >
      ${ne(Qs)}
    </button>`;
    return this.chatController.isProcessingResponse ? e : i;
  }
  renderChatEntryTabContent(i) {
    return w` <tab-component
      .tabs="${[
      {
        id: "tab-thought-process",
        label: T.THOUGHT_PROCESS_LABEL
      },
      {
        id: "tab-support-context",
        label: T.SUPPORT_CONTEXT_LABEL
      },
      {
        id: "tab-citations",
        label: T.CITATIONS_TAB_LABEL
      }
    ]}"
      .selectedTabId="${this.selectedAsideTab}"
    >
      <div slot="tab-thought-process" class="tab-component__content">
        ${i && i.thoughts ? w` <p class="tab-component__paragraph">${vt(i.thoughts)}</p> ` : ""}
      </div>
      <div slot="tab-support-context" class="tab-component__content">
        ${i && i.dataPoints ? w` <teaser-list-component
              .alwaysRow="${!0}"
              .teasers="${i.dataPoints.map((e) => ({ description: e }))}"
            ></teaser-list-component>` : ""}
      </div>
      ${i && i.citations ? w`
            <div slot="tab-citations" class="tab-component__content">
              <citation-list
                .citations="${i.citations}"
                .label="${T.CITATIONS_LABEL}"
                .selectedCitation="${this.selectedCitation}"
                @on-citation-click="${this.handleCitationClick}"
              ></citation-list>
              ${this.selectedCitation ? w`<document-previewer
                    url="${this.apiUrl}/content/${this.selectedCitation.text}"
                  ></document-previewer>` : ""}
            </div>
          ` : ""}
    </tab-component>`;
  }
  handleChatEntryActionButtonClick(i) {
    var e, t;
    ((e = i.detail) == null ? void 0 : e.id) === "chat-show-thought-process" && (this.selectedChatEntry = (t = i.detail) == null ? void 0 : t.chatThreadEntry, this.handleExpandAside(i));
  }
  willUpdate() {
    if (this.isDisabled = this.chatController.generatingAnswer, this.chatController.processingMessage) {
      const i = this.chatController.processingMessage, e = this.chatThread.findIndex((t) => t.id === i.id);
      this.chatThread = e > -1 ? Ge(this.chatThread, e, i) : [...this.chatThread, i];
    }
  }
  renderChatThread(i) {
    return w`<chat-thread-component
      .chatThread="${i}"
      .actionButtons="${[
      {
        id: "chat-show-thought-process",
        label: T.SHOW_THOUGH_PROCESS_BUTTON_LABEL_TEXT,
        svgIcon: Xs,
        isDisabled: this.isShowingThoughtProcess
      }
    ]}"
      .isDisabled="${this.isDisabled}"
      .isProcessingResponse="${this.chatController.isProcessingResponse}"
      .selectedCitation="${this.selectedCitation}"
      .isCustomBranding="${this.isCustomBranding}"
      .svgIcon="${di}"
      @on-action-button-click="${this.handleChatEntryActionButtonClick}"
      @on-citation-click="${this.handleCitationClick}"
      @on-followup-click="${this.handleQuestionInputClick}"
    >
    </chat-thread-component>`;
  }
  // Render the chat component as a web component
  render() {
    return w`
      <div id="overlay" class="overlay"></div>
      <section id="chat__containerWrapper" class="chat__containerWrapper">
        ${this.isCustomBranding && !this.isChatStarted ? w` <chat-stage
              svgIcon="${di}"
              pagetitle="${T.BRANDING_HEADLINE}"
              url="${T.BRANDING_URL}"
            >
            </chat-stage>` : ""}
        <section class="chat__container" id="chat-container">
          ${this.isChatStarted ? w`
                <div class="chat__header--thread">
                  ${this.interactionModel === "chat" ? this.chatHistoryController.renderHistoryButton({ disabled: this.isDisabled }) : ""}
                  <chat-action-button
                    .label="${T.RESET_CHAT_BUTTON_TITLE}"
                    actionId="chat-reset-button"
                    @click="${this.resetCurrentChat}"
                    .svgIcon="${Ys}"
                  >
                  </chat-action-button>
                </div>
                ${this.chatHistoryController.showChatHistory ? w`<div class="chat-history__container">
                      ${this.renderChatThread(this.chatHistoryController.chatHistory)}
                      <div class="chat-history__footer">
                        ${ne(ui)}
                        ${T.CHAT_HISTORY_FOOTER_TEXT.replace(
      T.CHAT_MAX_COUNT_TAG,
      Li
    )}
                        ${ne(ui)}
                      </div>
                    </div>` : ""}
                ${this.renderChatThread(this.chatThread)}
              ` : ""}
          ${this.chatController.isAwaitingResponse ? w`<loading-indicator label="${T.LOADING_INDICATOR_TEXT}"></loading-indicator>` : ""}
          <!-- Teaser List with Default Prompts -->
          <div class="chat__container">
            <!-- Conditionally render default prompts based on isDefaultPromptsEnabled -->
            ${this.isDefaultPromptsEnabled ? w`
                  <teaser-list-component
                    .heading="${this.interactionModel === "chat" ? dt.HEADING_CHAT : dt.HEADING_ASK}"
                    .clickable="${!0}"
                    .actionLabel="${dt.TEASER_CTA_LABEL}"
                    @teaser-click="${this.handleQuestionInputClick}"
                    .teasers="${dt.DEFAULT_PROMPTS}"
                  ></teaser-list-component>
                ` : ""}
          </div>
          <form
            id="chat-form"
            class="form__container ${this.inputPosition === "sticky" ? "form__container-sticky" : ""}"
          >
            <div class="chatbox__container container-col container-row">
              <div class="chatbox__input-container display-flex-grow container-row">
                <input
                  class="chatbox__input display-flex-grow"
                  data-testid="question-input"
                  id="question-input"
                  placeholder="${T.CHAT_INPUT_PLACEHOLDER}"
                  aria-labelledby="chatbox-label"
                  id="chatbox"
                  name="chatbox"
                  type="text"
                  :value=""
                  ?disabled="${this.isDisabled}"
                  autocomplete="off"
                  @keyup="${this.handleOnInputChange}"
                />
                ${this.isResetInput ? "" : w`<voice-input-button @on-voice-input="${this.handleVoiceInput}" />`}
              </div>
              ${this.renderChatOrCancelButton()}
              <button
                title="${T.RESET_BUTTON_TITLE_TEXT}"
                class="chatbox__button--reset"
                .hidden="${!this.isResetInput}"
                type="reset"
                id="resetBtn"
                title="Clear input"
                @click="${this.resetInputField}"
              >
                ${T.RESET_BUTTON_LABEL_TEXT}
              </button>
            </div>

            ${this.isDefaultPromptsEnabled ? "" : w`<div class="chat__containerFooter">
                  <button type="button" @click="${this.showDefaultPrompts}" class="defaults__span button">
                    ${T.DISPLAY_DEFAULT_PROMPTS_BUTTON}
                  </button>
                </div>`}
          </form>
        </section>
        ${this.isShowingThoughtProcess ? w`
              <aside class="aside" data-testid="aside-thought-process">
                <div class="aside__header">
                  <chat-action-button
                    .label="${T.HIDE_THOUGH_PROCESS_BUTTON_LABEL_TEXT}"
                    actionId="chat-hide-thought-process"
                    @click="${this.collapseAside}"
                    .svgIcon="${Js}"
                  >
                  </chat-action-button>
                </div>
                ${this.renderChatEntryTabContent(this.selectedChatEntry)}
              </aside>
            ` : ""}
      </section>
    `;
  }
};
P.styles = [js];
z([
  x({ type: String, attribute: "data-input-position" })
], P.prototype, "inputPosition", 2);
z([
  x({ type: String, attribute: "data-interaction-model" })
], P.prototype, "interactionModel", 2);
z([
  x({ type: String, attribute: "data-api-url" })
], P.prototype, "apiUrl", 2);
z([
  x({ type: String, attribute: "data-custom-branding", converter: (i) => (i == null ? void 0 : i.toLowerCase()) === "true" })
], P.prototype, "isCustomBranding", 2);
z([
  x({ type: String, attribute: "data-use-stream", converter: (i) => (i == null ? void 0 : i.toLowerCase()) === "true" })
], P.prototype, "useStream", 2);
z([
  x({ type: String, attribute: "data-overrides", converter: (i) => JSON.parse(i || "{}") })
], P.prototype, "overrides", 2);
z([
  x({ type: String, attribute: "data-custom-styles", converter: (i) => JSON.parse(i || "{}") })
], P.prototype, "customStyles", 2);
z([
  x({ type: String })
], P.prototype, "currentQuestion", 2);
z([
  ki("#question-input")
], P.prototype, "questionInput", 2);
z([
  Q()
], P.prototype, "isDisabled", 2);
z([
  Q()
], P.prototype, "isChatStarted", 2);
z([
  Q()
], P.prototype, "isResetInput", 2);
z([
  Q()
], P.prototype, "isShowingThoughtProcess", 2);
z([
  Q()
], P.prototype, "isDefaultPromptsEnabled", 2);
z([
  Q()
], P.prototype, "selectedCitation", 2);
z([
  Q()
], P.prototype, "selectedChatEntry", 2);
P = z([
  J("chat-component")
], P);
export {
  pe as ChatActionButtonComponent,
  P as ChatComponent,
  pn as ChatResponseError,
  re as ChatThreadComponent,
  Me as CitationListComponent,
  et as DocumentPreviewerComponent,
  wt as LoadingIndicatorComponent,
  Ke as TabComponent,
  he as TeaserListComponent,
  Je as VoiceInputButton,
  Hr as callHttpApi,
  io as cancelStream,
  Oi as chatEntryToString,
  Gs as cleanUpFollowUp,
  Br as createReader,
  Ur as getAPIResponse,
  Zs as getTimestamp,
  Ge as newListWithEntryAtIndex,
  jr as parseCitations,
  Fr as parseStreamedMessages,
  Ws as processText,
  qr as readStream,
  Vr as updateCitationsEntry,
  Gr as updateFollowingStepOrFollowupQuestionEntry,
  Wr as updateTextEntry
};
